import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
  Checkbox,
  IconButton,
  FormControlLabel,
  Button,
  Box,
  Modal,
  List,
  ListSubheader,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "./CreateDistributorModal.css";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import MultiSelectDropDown from "../../MultiSelectDropDown/MultiSelectDropDown";
import PhoneNumberTextbox from "../../PhoneNumberTextbox/PhoneNumberTextbox";
import BusinessPhoneNumberTextbox from "../../PhoneNumberTextbox/BusinessPhoneNumberTextbox";
import { useHistory } from "react-router";
import { usePageMode } from "../../../hooks/usePageMode";
import { useMasterData } from "../../../hooks/useMasterData";
import InlineMessage from "../../InlineMessage/InlineMessage";
import { getServiceInstance } from "../../../services/UserServices/UserService";
import { useLoading } from "../../../hooks/useLoader";
import SearchableDropDown from "../../SearchableDropDown/SearchableDropdown";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { TextField } from "@mui/material/";
import { useAuth } from "../../../hooks/useAuth";
import moment from "moment";
import { TABS } from "../../../constants/common";
import { MandatoryField } from "../../MandatoryFieldsIcon/MandatoryField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ApiServices from "../../../services/ApiServices";
import {
  PARENT_DISTRIBUTOR,
  UPLOAD_LOGO,
  SUBSCRIBER_RENEWAL_HISTORY,
  ENTERPRISE_GROUP_USER,
  ALL_ROLE_LIST,
} from "../../../constants/api-constants";
import filterRoles from "../../../utilities/filterRoles";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { SystemUsersEnum } from "../../../constants/SystemUsers";
import CurrencyTextbox from "../../../common/CurrencyTextbox/CurrencyTextbox";
import Confirmation from "../../Confirmation/Confirmation";
import {
  brandLogoAcceptedFormats,
  deleteSubscriptionConfirmationMessage,
  subscriptionStatusFilters,
} from "../../../screens/Distributors/constants";
import cloneDeep from "lodash/cloneDeep";
import FooterButtons from "../../FooterButtons/FooterButtons";
import { PermissionEnum } from "../../../constants/permissionService";
import FileUploader from "../../FileUploader/FileUploader";
import {
  fetchImageAsBase64,
  getBillingZipLabel,
  getBillingZipPlaceholder,
  getFileExtension,
  getMaxLength,
  getPhoneCode,
  getShippingZipLabel,
  getShippingZipPlaceholder,
  getZipLabel,
  getZipPlaceholder,
  isCountryCanada,
} from "../../../utilities/common";
import { getSecureRandomInt } from "../../../utilities/secureRandom";
import MultiSelectCheckboxSearchableDropdown from "../MultiSelectCheckboxSearchableDropdown/MultiSelectCheckboxSearchableDropdown";
import { SubscriberRenewalHistoryColumns } from "../../../common/TableColumnModal/DefaultDataColumns";
import DataTable from "../../../screens/Tables/DataTable/DataTable";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import CheckboxList from "../../../common/CheckboxList/CheckboxList";
import Popover from "@mui/material/Popover";
import Group2252459 from "../../../common/Modal/Distributor/Group2252459.png";
import { AssociationStatusEnum } from "../AssociationStatusEnum";
import Group2252519 from "../../../common/Modal/Distributor/Group2252519.png";
import PropTypes from "prop-types";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

function SMSConcentCheckBox({
  isSubscriberType,
  isEditMode,
  isSmsConsentGiven,
  onSmsConsentChange,
}) {
  return isSubscriberType ? (
    <Grid item xs={12} p={2} className="blue-field-section">
      <FormControlLabel
        control={
          <Checkbox
            checked={isSmsConsentGiven || false}
            onChange={(e) => onSmsConsentChange(e.target.checked)}
            name="isSmsConsentGiven"
            color="primary"
          />
        }
        disabled={!isEditMode}
        label="I agree to receive one-time passcodes and account-related SMS messages to this phone number. Message & data rates may apply. Reply STOP to opt out, HELP for help."
        sx={{
          "& .MuiFormControlLabel-label": {
            fontSize: "0.875rem",
            lineHeight: "1.5",
            color: "#333",
          },
        }}
      />
    </Grid>
  ) : null;
}

SMSConcentCheckBox.propTypes = {
  isSubscriberType: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  isSmsConsentGiven: PropTypes.bool,
  onSmsConsentChange: PropTypes.func.isRequired,
};

SMSConcentCheckBox.defaultProps = {
  isSmsConsentGiven: false,
};

/*istanbul ignore next */
const CreateDistributorModal = (props) => {
  const {
    basicDetailPermission,
    associationDetailsPermission,
    subscriptionDetailsPermission,
  } = props;
  const [parentDropdown, setParentDropdown] = useState([]);
  const { permissions } = props;
  const history = useHistory();
  const auth = useAuth();
  const page = usePageMode();
  const { showLoader } = useLoading();
  const permissionId = auth.getPermissionId();
  const frequencyOptions = [
    { label: "Monthly", value: 1 },
    { label: "Quarterly", value: 2 },
    { label: "Semi-Annual", value: 3 },
    { label: "Annual", value: 4 },
  ];
  const FrequencyType = {
    1: "Monthly",
    2: "Quarterly",
    3: "Semi-Annual",
    4: "Annual",
  };

  const AllFrequencyType = {
    99: "One Time Cost",
    ...FrequencyType,
  };

  const ContentTypeEnum = {
    1: "Content",
    2: "Catalog",
    3: "Bundle",
  };

  const userService = getServiceInstance(props.routeData?.userTypeId);
  const currentUserId = auth.getCurrentUser()?.userId;
  const currentUserBrandName = auth.getCurrentUser()?.brandName;

  const masterDataContext = useMasterData();
  let hidden = true;
  const maxSizeInBytes = 2 * 1024 * 1024; // 2MB in bytes
  const maxSizeExeedError =
    "File size exceeds maximum 2MB allowed. Kindly reduce the size of the file before proceeding"; // 2MB Exeeded

  useEffect(() => {
    if (props.formData.userId > 0) {
      formik.setValues(props.formData);
      let data = parentDropdown.filter(
        (x) => x.userId === props.formData.parentUser?.parentUserId
      );

      setSelectedValue(
        data.map((res) => {
          return {
            label: res.name,
            id: res.userId,
          };
        })
      );
      setMembership(
        props.formData.parentUser?.parentUserId
          ? `INCHANTED_${props.formData.parentUser?.parentUserId}`
          : ""
      );
      setRoles(props.formData.roles);
    } else {
      formik.validateForm();
      if (localStorage.getItem("DefaultSubscriberEmail")) {
        formik.setFieldValue(
          "primaryEmail",
          localStorage.getItem("DefaultSubscriberEmail")
        );
      }
    }
  }, [props.formData, props.formData.userId, parentDropdown]);

  const [viewForm, setViewForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedSubItem, setSelectedSubItem] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [type, setType] = useState("");
  const [showAnotherNumber, setShowAnotherNumber] = useState(false);
  const [showAnotherMobile, setShowAnotherMobile] = useState(false);
  const [showAnotherFax, setShowAnotherFax] = useState(false);
  const [distributorTypeOptions, setDistributorTypeOptions] = useState([]);
  const [annualRevenues, setAnnualRevenues] = useState([]);
  const [numberOfEmployees, setNumberOfEmployees] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  const [career, setCareer] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [carrier, setCarrier] = useState([]);
  const [associationPopupConfirmation, setAssociationPopupConfirmation] =
    useState(false);
  const [technology, setTechnology] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [allStateOptions, setAllStateOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const isStatusValid = props.formData.status > 0;
  const isNotDistributor =
    props.routeData?.userTypeId !== SystemUsersEnum.DISTRIBUTOR;
  const [isEditMode, setIsEditMode] = useState(
    (isStatusValid || isNotDistributor) && props.isEditMode
  );
  const [enterpriseTypes, setEnterpriseTypes] = useState([]);
  const [distributorTypes, setDistributorTypes] = useState([]);
  const [memberShip, setMembership] = useState(null);
  const [logo, setLogo] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [entUserDists, setEntUserDists] = useState([]);
  const [renewalHistoryQuery, setRenewalHistoryQuery] = useState({
    searchText: "",
    SortType: "asc",
    SortColumn: "startDate",
    PageNumber: 1,
    PageSize: 10,
    filter: {
      SubscriberId: 0,
      SubscriptionId: 0,
      IsEgSubscription: false,
    },
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [expandedFilter, setExpandedFilter] = useState("NA");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedFreq, setSelectedFreq] = useState([]);
  const [filterQuery, setFilterQuery] = useState({
    status: [1, 4],
    frequency: [1, 2, 3, 4],
  });
  const [shippingStateOptions, setShippingStateOptions] = useState([]);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const clearFilterHandler = () => {
    setFilterQuery({
      status: [1, 4],
      frequency: [1, 2, 3, 4],
    });
    setSelectedStatus([]);
    setSelectedFreq([]);
  };
  const applyFilterHandler = () => {
    setFilterQuery((prevState) => {
      return {
        ...prevState,
        status: selectedStatus.length > 0 ? selectedStatus : [1, 4],
        frequency: selectedFreq.length > 0 ? selectedFreq : [1, 2, 3, 4],
      };
    });
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const filterAccordianHandleChange = (panel) => (event, isExpanded) => {
    setExpandedFilter(isExpanded ? panel : "NA");
  };

  const onFilterStatusChangeHandler = (values) => {
    setSelectedStatus(values);
  };
  const onFilterFreqChangeHandler = (values) => {
    setSelectedFreq(values);
  };

  const formik = useFormik({
    initialValues: {
      ...props.formData,
      isShippingAddressSameAsBilling:
        typeof props.formData.isShippingAddressSameAsBilling === "boolean"
          ? props.formData.isShippingAddressSameAsBilling
          : true,
      shippingContactName: props.formData.shippingContactName || "",
      shippingContactLastName: props.formData.shippingContactLastName || "",
      shippingPhoneNumber: props.formData.shippingPhoneNumber || "",
      shippingAddressLine1: props.formData.shippingAddressLine1 || "",
      shippingAddressLine2: props.formData.shippingAddressLine2 || "",
      shippingCountryId: props.formData.shippingCountryId || null,
      shippingStateId: props.formData.shippingStateId || null,
      shippingCity: props.formData.shippingCity || "",
      shippingZipCode: props.formData.shippingZipCode || "",
      isSmsConsentGiven: props.formData.isSmsConsentGiven || false,
    },
    enableReinitialize: true,
    validationSchema: props?.routeData?.schema,
  });
  const isShippingAddressSameAsBilling =
    formik.values.isShippingAddressSameAsBilling;
  useEffect(() => {
    if (typeof props.formData.isShippingAddressSameAsBilling === "boolean") {
      formik.setFieldValue(
        "isShippingAddressSameAsBilling",
        props.formData.isShippingAddressSameAsBilling
      );
    }
  }, [props.formData.isShippingAddressSameAsBilling]);

  const populateAssociatedDistBrandName = async () => {
    try {
      showLoader(true);
      const response = await ApiServices.httpGet(
        `${ENTERPRISE_GROUP_USER}/${currentUserId}`
      );
      if (response.responseStatus.isSuccess) {
        let approvedDistList = response.result.associateDistributors;
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        let filteredList = approvedDistList.filter(
          (item) =>
            !item.isStopped &&
            (!item.expirationDate ||
              moment(item.expirationDate).format("YYYY-MM-DD") >=
              moment(today).format("YYYY-MM-DD")) &&
            moment(item.startDate).format("YYYY-MM-DD") <=
            moment(today).format("YYYY-MM-DD") &&
            item.associatonStatus === AssociationStatusEnum.Approved
        );

        let finalList = [
          ...new Map(
            filteredList.map((item) => [item["distributorUserId"], item])
          ).values(),
        ];

        setEntUserDists(finalList);
      } else {
        toast.success(response.responseStatus.error);
      }
      showLoader(false);
    } catch {
      toast.error("Internal Server Error");
    }
  };

  useState(() => {
    if (auth.getRole() === SystemUsersEnum.ENTERPRISE) {
      populateAssociatedDistBrandName();
    }
  });

  useEffect(() => {
    page.setDirty(formik.values.dirty);
  }, [formik.values.dirty]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("DefaultSubscriberEmail");
    };
  }, []);

  useEffect(() => {
    if (props.formData.userId > 0) {
      formik.setValues(props.formData);
      setRoles(props.formData.roles);
      populateDropdownParent();
    }
  }, [props.formData, props.formData.userId]);

  useEffect(() => {
    setIsEditMode((prevState) => {
      return props.formData.status > 0 && prevState;
    });
  }, [props.formData.status]);

  useEffect(() => {
    if (
      props.formData.enterpriseIds ||
      (props.formData.distributorIds && enterpriseTypes.allEnterpriseUsers) ||
      distributorTypes.allDistributorUsers
    ) {
      getValueForDistributorId(props.formData.distributorIds);
      getValueForEnterpriseGroupId(props.formData.enterpriseIds);
    }
  }, [
    props.formData.enterpriseIds,
    props.formData.distributorIds,
    enterpriseTypes.allEnterpriseUsers,
    distributorTypes.allDistributorUsers,
  ]);

  const [expanded, setExpanded] = React.useState("panel1");
  const [permissionList, setPermissionList] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [allRoles, setAllRoles] = useState([]);
  const options = allRoles?.map((item) => item.name);
  const [selected, setSelected] = useState([]);
  const isAllSelected = isAllSelectedFunction(options, selected);
  const [subscriberRenewalHistoryList, setSubscriberRenewalHistoryList] =
    useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const handleChangePageNumber = (event, newPage) => {
    setCurrentPage(newPage);
    setRenewalHistoryQuery((prevState) => {
      return { ...prevState, PageNumber: newPage };
    });
  };
  const isNotDistributors =
    props.routeData?.userTypeId !== SystemUsersEnum.DISTRIBUTOR;
  const canUpdateBasic = basicDetailPermission?.includes(PermissionEnum.UPDATE);
  const canUpdateAssociation = associationDetailsPermission?.includes(
    PermissionEnum.UPDATE
  );
  const canUpdateSubscription = subscriptionDetailsPermission?.includes(
    PermissionEnum.UPDATE
  );
  const hasEditCondition = isStatusValid || isNotDistributors;

  const editPermissionBasic = hasEditCondition && canUpdateBasic;
  const editPermissionAssociation = hasEditCondition && canUpdateAssociation;
  const editPermissionSubscripiton = hasEditCondition && canUpdateSubscription;

  const pageSizeChangeHandler = (PageSize) => {
    setRenewalHistoryQuery((prevState) => {
      return { ...prevState, PageSize: PageSize, PageNumber: 1 };
    });
  };

  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleChangeDropDown = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options.length ? [] : options);
      formik.setFieldValue(
        "roles",
        selected.length === options.length ? [] : options
      );
      return;
    }
    setSelected(value);
    formik.setFieldValue("roles", value);
  };

  const setRoles = (rolesData) => {
    if (rolesData) {
      const userData = rolesData.map((item) => item.name);
      setSelected(userData);
    }
  };

  useEffect(() => {
    setMasterData();
    getDistributorDropDownDataList();
    populateDropdownParent();
  }, []);

  const getDistributorDropDownDataList = async () => {
    try {
      const data = masterDataContext.masterDataValue;
      setPermissionList(data.result.parentPermissions);
    } catch {
      toast.error("Internal Server Error");
    }
  };

  const populateDropdownParent = async () => {
    try {
      const data = await ApiServices.httpGet(`${PARENT_DISTRIBUTOR}`);
      const result = data.result.filter(
        (res) => res.userId !== props.formData.userId
      );
      setParentDropdown(result);
    } catch {
      toast.error("Internal Server Error");
    }
  };

  const getRenewalHistory = async (item) => {
    try {
      showLoader(true);
      let queryState = { ...renewalHistoryQuery };
      if (item) {
        queryState.filter.SubscriptionId = item.requestId;
        queryState.filter.SubscriberId = formik.values.userId;
      }
      setRenewalHistoryQuery(queryState);
      let response = await ApiServices.httpGet(
        `${SUBSCRIBER_RENEWAL_HISTORY}?query=${JSON.stringify(queryState)}`
      );
      if (response.responseStatus.isSuccess) {
        let subRenewalList = response.result.records.map((x) => {
          return {
            brandName: x.brandName,
            subscriptionName: x.subscriptionName,
            frequencyText: FrequencyType[x.frequencyType],
            isRecurring: x.isRecurring,
            subscriptionFees: x.subscriptionFees,
            startDate: x.startDate,
            endDate: x.endDate,
          };
        });
        setSubscriberRenewalHistoryList(subRenewalList);
        setTotalPages(response?.result?.totalPages);
        setPageSize(response?.result?.pageSize);
        setCurrentPage(response?.result?.currentPage);
      } else {
        toast.success(response.responseStatus.error);
      }
      showLoader(false);
    } catch (e) {
      showLoader(false);
    }
  };

  useEffect(() => {
    const distributorTypes = formik.values.distributorType || [];
    const hasAgent = distributorTypes.some(
      (e) => e.label === "Agents / Broker"
    );
    if (hasAgent && distributorTypes.length === 1) {
      setType("agent");
    } else if (hasAgent) {
      setType("all");
    } else {
      setType("other");
    }
  }, [formik.values.distributorType]);

  const populateStateOptions = (countryId) => {
    const result =
      allStateOptions?.filter(
        (res) => Number(res.countryId) === Number(countryId)
      ) || [];
    setStateOptions(result);
  };

  const handleEditModalCancelClick = (item, subItem) => {
    setOpenConfirmation(true);
    setSelectedItem(item.uid);
    setSelectedSubItem(subItem.uniqueId);
  };

  const handleFieldChange = (fieldName, e) => {
    if (fieldName === "firstName") {
      formik.setFieldValue("dirty", true);
      formik.setFieldValue("billingContact", e.target.value);
    }
    formik.handleChange(e);
    formik.setFieldValue(fieldName, e.target.value);
  };
  const handleFieldChanges = (fieldName, e) => {
    if (fieldName === "lastName") {
      formik.setFieldValue("dirty", true);
      formik.setFieldValue("billingContactLastName", e.target.value);
    }
    formik.handleChange(e);
    formik.setFieldValue(fieldName, e.target.value);
  };

  const renderConfirmationPopup = () => {
    return (
      <Modal
        open={associationPopupConfirmation}
        onClose={() => {
          handleChangePageNumber("", 1);
          setAssociationPopupConfirmation(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <button
            type="button"
            onClick={() => {
              handleChangePageNumber("", 1);
              setAssociationPopupConfirmation(false);
            }}
            className="close-button"
            aria-label="Close popup"
            data-testid="CloseNewAdminPopup"
            style={{
              cursor: "pointer",
              justifyContent: "end",
              display: "flex",
              marginTop: "5px",
              background: "none",
              border: "none",
              padding: 0,
            }}
          >
            <CloseOutlinedIcon />
          </button>

          <Typography
            id="modal-modal-description"
            sx={{
              mb: 2,
              mt: -2,
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            Renewal History
          </Typography>

          <div>
            <DataTable
              checkboxesNotRequired={true}
              serachBarNotRequired={true}
              columns={SubscriberRenewalHistoryColumns}
              adminTable={subscriberRenewalHistoryList}
              query={renewalHistoryQuery}
              totalPages={totalPages}
              pageSize={pageSize}
              page={currentPage}
              handleChangePage={handleChangePageNumber}
              onPageSizeChange={pageSizeChangeHandler}
            />
          </div>
        </Box>
      </Modal>
    );
  };

  useEffect(() => {
    populateStateOptions(formik.values.countryId || 1);
  }, [formik.values.countryId, allStateOptions]);

  const setMasterData = async () => {
    try {
      showLoader(true);
      const response = await userService.populateDropdownOptions();
      const adminData = await ApiServices.httpGet(`${ALL_ROLE_LIST}`);
      showLoader(false);
      response.roles = adminData?.result?.records;
      let allRolesList = filterRoles(
        props.routeData.userTypeId,
        response.roles
      );
      setAllRoles(allRolesList);
      if (props?.routeData?.userTypeId === SystemUsersEnum.SUBSCRIBER) {
        setSelected(allRolesList.map((item) => item.name));
      }
      setDistributorTypeOptions(response.userTypeOptions);
      setCountryOptions(response.countries);
      setAllStateOptions(response.states);
      setAnnualRevenues(response.annualRevenues);
      setNumberOfEmployees(response.numberOfEmployees);
      setAreaOptions(response.areas);
      setCareer(response.carrierRepresents);
      setIndustry(response.industryGroups);
      setCarrier(response.carriers);
      setTechnology(response.technologies);
      if (auth.getRole() === 1 || auth.getRole() === 2) {
        let allEnterpriseUsers = await userService.populateEnterpriseDropdown();
        setEnterpriseTypes(allEnterpriseUsers);
        let allDistributorUsers =
          await userService.populateDistributorDropdown();
        setDistributorTypes(allDistributorUsers);
      }
    } catch (e) {
      showLoader(false);
    }
  };

  const permissionChange = (index, id, column) => {
    let arr = formik.values;
    if (arr.parentUser.permissions[index]) {
      arr.parentUser.permissions[index][column] =
        !arr.parentUser.permissions[index][column];
      arr.parentUser.permissions[index]["parentPermissionMasterId"] = id;
    } else {
      arr.parentUser.permissions[index] = {
        parentUserPermissionId: 0,
        userId: 0,
        parentUserId: 0,
        parentPermissionMasterId: id,
        isRead: column === "isRead" ? true : false,
        isWrite: column === "isWrite" ? true : false,
        isNoAccess: column === "isNoAccess" ? true : false,
      };
    }
  };

  const createDistributor = async (isNext) => {
    try {
      showLoader(true);
      let payload = cloneDeep(formik.values);
      reversePayloadSubs(payload);
      if (validateSubscriptions(payload.distributorSubscriptionDomains)) {
        toast.error(
          "Subscription Name already exists. Please choose a different name."
        );
        showLoader(false);
        return;
      }
      setRolesMethod(allRoles, selected, payload);

      formattingPayload(payload, props, auth, currentUserId);
      const response = await userService.createUser(payload);
      showLoader(false);
      if (response.responseStatus.isSuccess) {
        createUserSuccess(
          page,
          response,
          setIsEditMode,
          props,
          executeScroll,
          isNext,
          history
        );
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch (event) {
      console.log("error", event);
      showLoader(false);
      toast.error("Internal server error");
    }
  };

  const updateDistributor = async (isNext) => {
    try {
      showLoader(true);
      page.setDirty(false);
      let payload = cloneDeep(formik.values);
      reversePayloadSubs(payload);
      if (validateSubscriptions(payload.distributorSubscriptionDomains)) {
        toast.error(
          "Subscription Name already exists. Please choose a different name."
        );
        showLoader(false);
        return;
      }
      let roles = [];
      if (formik.values.userId) {
        roles = props.formData.roles;
      } else {
        roles = allRoles.filter((element) => selected.includes(element.name));
      }
      payload.roles = roles;
      if (
        formik.values.logoGcpFileUrl &&
        auth.getCurrentUser().userId === formik.values.userId
      ) {
        await fetchImageAsBase64(formik.values.logoGcpFileUrl).then((data) => {
          auth.setBrandImage(data);
        });
      } else {
        auth.setBrandImage(null);
      }
      formattingPayload(payload, props, auth, currentUserId);
      const response = await userService.updateUser(payload);
      showLoader(false);
      if (response.responseStatus.isSuccess) {
        formik.setFieldValue(
          "distributorSubscriptionDomains",
          formik.values.distributorSubscriptionDomains
        );
        page.setEditMode(false);
        setIsEditMode(false);
        setEditMode(false);
        props.onNext(isNext, response.result);
        toast.success(response.responseStatus.description);
        executeScroll();
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch (event) {
      showLoader(false);
      toast.error("Internal server error");
    }
  };
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const onChangeEnterpriseGroupId = (newValue) => {
    page.setDirty(true);
    formik.setFieldValue("enterpriseIds", newValue);
  };

  const onChangeDistributorUserId = (newValue) => {
    page.setDirty(true);
    formik.setFieldValue("distributorIds", newValue);
  };

  const handleCancelClick = () => {
    history.push(props.routeData?.listRoute);
  };

  const handleZipChange = (e, formik) => {
    formik.setFieldValue("dirty", true);
    const formattedValue = isCountryCanada(formik.values.countryId)
      ? formatCanadianPostalCode(e.target.value)
      : formatUSZipCode(e.target.value);
    formik.setFieldValue("zip", formattedValue);
  };

  const handleChangeValue = (e, which) => {
    try {
      if (which === "subscriptionId") {
        formik.setFieldValue(`subscription.${which}`, e?.target?.value);
      } else {
        let d = e?._d || "";
        formik.setFieldValue(
          `subscription.${which}`,
          moment(d).format("YYYY-MM-DD")
        );
      }
    } catch (error) {
      console.log("date error", error);
    }
  };
  const handleChangeValueegSubscription = (e, which, index) => {
    try {
      let d = e?._d || "";
      formik.setFieldValue(
        `egSubscriptions[${index}].${which}`,
        moment(d).format("YYYY-MM-DD")
      );
    } catch (error) {
      console.log("date error", error);
    }
  };

  const getValueForEnterpriseGroupId = (entIds) => {
    let retVal = [];
    if (entIds?.length) {
      entIds.forEach((element) => {
        enterpriseTypes?.allEnterpriseUsers?.forEach((item) => {
          if (element === item.value) retVal.push(item);
        });
      });
    }
    formik.setFieldValue("enterpriseIds", retVal);
    return retVal;
  };

  const getValueForDistributorId = (distIds) => {
    let retVal = [];
    if (distIds?.length) {
      distIds.forEach((element) => {
        distributorTypes?.allDistributorUsers?.forEach((item) => {
          if (element === item.value) retVal.push(item);
        });
      });
    }
    formik.setFieldValue("distributorIds", retVal);
    return retVal;
  };

  const myRef = useRef(null);
  const executeScroll = () =>
    myRef?.current?.firstChild?.scrollIntoView({
      behavior: "smooth",
    });

  const MenuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };
  useEffect(() => {
    if (!formik.values.shippingCountryId && countryOptions?.length) {
      const us = countryOptions.find((c) =>
        /^(US|USA|United States)$/i.test(c.name)
      );
      if (us) {
        formik.setFieldValue("shippingCountryId", us.countryId);
      }
    }
  }, [countryOptions, formik.values.shippingCountryId]);

  useEffect(() => {
    if (formik.values.shippingCountryId) {
      const result =
        allStateOptions?.filter(
          (res) =>
            Number(res.countryId) === Number(formik.values.shippingCountryId)
        ) || [];
      setShippingStateOptions(result);
    } else {
      setShippingStateOptions([]);
    }
  }, [formik.values.shippingCountryId, allStateOptions]);

  useEffect(() => {
    if (formik.values.isShippingAddressSameAsBilling) {
      formik.setValues({
        ...formik.values,
        shippingContactName: formik.values.billingContact || "",
        shippingContactLastName: formik.values.billingContactLastName || "",
        shippingPhoneNumber: formik.values.billingPhoneNumber || "",
        shippingAddressLine1: formik.values.billingAddressLine1 || "",
        shippingAddressLine2: formik.values.billingAddressLine2 || "",
        shippingCountryId: formik.values.countryId || null,
        shippingStateId: formik.values.stateId || null,
        shippingCity: formik.values.city || "",
        shippingZipCode: formik.values.zip || "",
      });
    }
  }, [
    formik.values.isShippingAddressSameAsBilling,
    formik.values.billingContact,
    formik.values.billingContactLastName,
    formik.values.billingPhoneNumber,
    formik.values.billingAddressLine1,
    formik.values.billingAddressLine2,
    formik.values.countryId,
    formik.values.stateId,
    formik.values.city,
    formik.values.zip,
  ]);

  const handleShippingZipChange = (e) => {
    const formattedValue = isCountryCanada(formik.values.shippingCountryId)
      ? formatCanadianPostalCode(e.target.value)
      : formatUSZipCode(e.target.value);
    formik.setFieldValue("shippingZipCode", formattedValue);
  };

  const renderSubscriptionDetails = (item, index) => {
    return (
      <div>
        <Grid container spacing={0} className="blue-field-section">
          <Grid item xs={12} p={1}>
            {item.isEgSubscription ? (
              <Grid container>
                <Grid
                  item
                  xs={1.3}
                  md={1.3}
                  p={1}
                  className="blue-field-section"
                >
                  <label
                    htmlFor="subscriptionName"
                    style={{
                      width: "129px",
                      lineBreak: "anywhere",
                      marginTop: "-16px",
                      marginBottom: "0px",
                    }}
                  >
                    Enterprise Group Brand Name
                  </label>
                  <input
                    id="subscriptionName"
                    data-testid={"subscription-dropdown"}
                    name="subscriptionName"
                    value={formik.values?.egSubscriptions[index]?.brandName}
                    className="form-control form-select"
                    disabled
                  />
                </Grid>

                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.3}
                    md={1.3}
                    p={1}
                    className="blue-field-section"
                  >
                    <label
                      htmlFor="subscription"
                      style={{
                        width: "129px",
                        lineBreak: "anywhere",
                        marginTop: "-16px",
                        marginBottom: "0px",
                      }}
                    >
                      Distributor Brand Name
                    </label>
                    <input
                      id="subscription"
                      data-testid={"subscription-dropdown"}
                      name="subscription"
                      value={
                        formik.values?.egSubscriptions[index]?.distBrandName
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleChangeValue(e, "subscriptionId");
                      }}
                      className="form-control form-select"
                      disabled
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.4}
                    md={1.4}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="subscription">Subscription Type</label>
                    <input
                      id="subscription"
                      data-testid={"subscription-dropdown"}
                      name="subscription"
                      value={
                        formik.values?.egSubscriptions[index]?.subscriptionName
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleChangeValue(e, "subscriptionId");
                      }}
                      className="form-control form-select"
                      disabled
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.2}
                    md={1.2}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="frequencyType">Frequency</label>
                    <input
                      id="subscription"
                      data-testid={"subscription-dropdown"}
                      name="subscription"
                      value={
                        AllFrequencyType[
                        formik.values?.egSubscriptions[index]?.frequencyType
                        ]
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleChangeValue(e, "subscriptionId");
                      }}
                      className="form-control form-select"
                      disabled
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.5}
                    md={1.5}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="associationId">Auto Renewal</label>
                    <FormControlLabel
                      className={
                        !isEditMode
                          ? "content-checkbox-field form-label border-cus-cus form-control input-border  cuss-cus-fm border-cus-cus-disabled"
                          : "content-checkbox-field form-label border-cus-cus form-control input-border  cuss-cus-fm"
                      }
                      label={<Typography>Auto Renewal</Typography>}
                      checked={
                        formik.values.egSubscriptions[index]?.isRecurring
                      }
                      name="Available Public"
                      data-testid="preview-available-checkbox"
                      control={<Checkbox disabled />}
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.6}
                    md={1.6}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="associationId">Subscription Amount</label>
                    <CurrencyTextbox
                      id="associationId"
                      name="associationId"
                      value={formik.values?.egSubscriptions[
                        index
                      ]?.subscriptionFees.toFixed(2)}
                      disabled
                      type="number"
                    />
                  </Grid>
                )}

                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.2}
                    md={1.2}
                    p={1}
                    className="blue-field-section date-picker-matui desktop-date-picker"
                  >
                    <label htmlFor="startDate">Start Date</label>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DesktopDatePicker
                        disablePast
                        className="form-label form-control date-field"
                        inputFormat="MM/DD/YYYY"
                        value={
                          formik.values?.egSubscriptions[index]?.startDate ||
                          null
                        }
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          handleChangeValueegSubscription(
                            e,
                            "startDate",
                            index
                          );
                        }}
                        renderInput={(params) => (
                          <TextField id="startDate" {...params} />
                        )}
                        disabled
                      />
                    </LocalizationProvider>
                    {formik.errors?.egSubscriptions?.length > 0 &&
                      index < formik.errors?.egSubscriptions?.length && (
                        <InlineMessage
                          error={
                            formik.errors?.egSubscriptions[index]?.startDate
                          }
                        />
                      )}
                  </Grid>
                )}

                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.2}
                    md={1.2}
                    p={1}
                    className="blue-field-section date-picker-matui desktop-date-picker"
                  >
                    <label htmlFor="endDate"> End Date</label>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DesktopDatePicker
                        disablePast
                        className="form-label form-control date-field"
                        inputFormat="MM/DD/YYYY"
                        value={
                          formik.values?.egSubscriptions[index]?.endDate || null
                        }
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          handleChangeValueegSubscription(e, "endDate", index);
                        }}
                        renderInput={(params) => (
                          <TextField id="endDate" {...params} />
                        )}
                        disabled
                      />
                    </LocalizationProvider>
                    {formik.errors?.egSubscriptions?.length > 0 &&
                      index < formik.errors?.egSubscriptions?.length && (
                        <InlineMessage
                          error={formik.errors?.egSubscriptions[index]?.endDate}
                        />
                      )}
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.3}
                    md={1.3}
                    p={1}
                    className=" blue-field-section"
                  >
                    <Button
                      style={{ marginTop: "20px" }}
                      onClick={() => {
                        renewalhistory(formik.values?.egSubscriptions[index]);
                      }}
                    >
                      Renewal History
                    </Button>
                  </Grid>
                )}
              </Grid>
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={1.3}
                  md={1.3}
                  p={1}
                  className="blue-field-section"
                >
                  <label
                    htmlFor="subscriptionName"
                    style={{
                      width: "129px",
                      lineBreak: "anywhere",
                      marginTop: "-26px",
                    }}
                  >
                    Content/Catalog/Bundle Name
                  </label>
                  <input
                    id="subscriptionName"
                    data-testid={"subscription-dropdown"}
                    name="subscriptionName"
                    value={
                      formik.values?.egSubscriptions[index]?.subscriptionName
                    }
                    className="form-control form-select"
                    disabled
                  />
                </Grid>

                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.3}
                    md={1.3}
                    p={1}
                    className="blue-field-section"
                  >
                    <label
                      htmlFor="subscription"
                      style={{
                        width: "129px",
                        lineBreak: "anywhere",
                        marginTop: "-26px",
                      }}
                    >
                      Distributor Brand Name
                    </label>
                    <input
                      id="subscription"
                      data-testid={"subscription-dropdown"}
                      name="subscription"
                      value={
                        formik.values?.egSubscriptions[index]?.distBrandName
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleChangeValue(e, "subscriptionId");
                      }}
                      className="form-control form-select"
                      disabled
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.4}
                    md={1.4}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="subscription">Type</label>
                    <input
                      id="subscription"
                      data-testid={"subscription-dropdown"}
                      name="subscription"
                      value={
                        ContentTypeEnum[
                        formik.values?.egSubscriptions[index]?.documentType
                        ]
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleChangeValue(e, "subscriptionId");
                      }}
                      className="form-control form-select"
                      disabled
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.2}
                    md={1.2}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="frequencyType">Frequency</label>
                    <input
                      id="subscription"
                      data-testid={"subscription-dropdown"}
                      name="subscription"
                      value={
                        AllFrequencyType[
                        formik.values?.egSubscriptions[index]?.frequencyType
                        ]
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleChangeValue(e, "subscriptionId");
                      }}
                      className="form-control form-select"
                      disabled
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.5}
                    md={1.5}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="associationId">Auto Renewal</label>
                    <FormControlLabel
                      className={
                        !isEditMode
                          ? "content-checkbox-field form-label border-cus-cus form-control input-border  cuss-cus-fm border-cus-cus-disabled"
                          : "content-checkbox-field form-label border-cus-cus form-control input-border  cuss-cus-fm"
                      }
                      label={<Typography>Auto Renewal</Typography>}
                      checked={
                        formik.values.egSubscriptions[index]?.isRecurring
                      }
                      name="Available Public"
                      data-testid="preview-available-checkbox"
                      control={<Checkbox disabled />}
                    />
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.6}
                    md={1.6}
                    p={1}
                    className="blue-field-section"
                  >
                    <label htmlFor="associationId">Subscription Amount</label>
                    <CurrencyTextbox
                      id="associationId"
                      name="associationId"
                      value={formik.values?.egSubscriptions[
                        index
                      ]?.subscriptionFees.toFixed(2)}
                      disabled
                      type="number"
                    />
                  </Grid>
                )}

                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.2}
                    md={1.2}
                    p={1}
                    className="blue-field-section date-picker-matui desktop-date-picker"
                  >
                    <label htmlFor="startDate">Start Date</label>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DesktopDatePicker
                        disablePast
                        className="form-label form-control date-field"
                        inputFormat="MM/DD/YYYY"
                        value={
                          formik.values?.egSubscriptions[index]?.startDate ||
                          null
                        }
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          handleChangeValueegSubscription(
                            e,
                            "startDate",
                            index
                          );
                        }}
                        renderInput={(params) => (
                          <TextField id="startDate" {...params} />
                        )}
                        disabled
                      />
                    </LocalizationProvider>
                    {formik.errors?.egSubscriptions?.length > 0 &&
                      index < formik.errors?.egSubscriptions?.length && (
                        <InlineMessage
                          error={
                            formik.errors?.egSubscriptions[index]?.startDate
                          }
                        />
                      )}
                  </Grid>
                )}

                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.2}
                    md={1.2}
                    p={1}
                    className="blue-field-section date-picker-matui desktop-date-picker"
                  >
                    <label htmlFor="endDate"> End Date</label>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DesktopDatePicker
                        disablePast
                        className="form-label form-control date-field"
                        inputFormat="MM/DD/YYYY"
                        value={
                          formik.values?.egSubscriptions[index]?.endDate || null
                        }
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          handleChangeValueegSubscription(e, "endDate", index);
                        }}
                        renderInput={(params) => (
                          <TextField id="endDate" {...params} />
                        )}
                        disabled
                      />
                    </LocalizationProvider>
                    {formik.errors?.egSubscriptions?.length > 0 &&
                      index < formik.errors?.egSubscriptions?.length && (
                        <InlineMessage
                          error={formik.errors?.egSubscriptions[index]?.endDate}
                        />
                      )}
                  </Grid>
                )}
                {props?.routeData?.userTypeId === 7 && (
                  <Grid
                    item
                    xs={1.3}
                    md={1.3}
                    p={1}
                    className=" blue-field-section"
                  >
                    <Button
                      style={{ marginTop: "20px" }}
                      onClick={() => {
                        renewalhistory(formik.values?.egSubscriptions[index]);
                      }}
                    >
                      Renewal History
                    </Button>
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  const renewalhistory = (item) => {
    setAssociationPopupConfirmation(true);
    getRenewalHistory(item);
  };

  const renderMultiSelectRolesDropdown = () => {
    return (
      <div style={{ width: "100%" }}>
        <label htmlFor="rolesDropdown">Roles</label>
        <MandatoryField />
        <Select
          displayEmpty
          disabled={
            formik.values.userId ||
            !isEditMode ||
            props?.routeData?.userTypeId === SystemUsersEnum.SUBSCRIBER
          }
          data-testid="rolesDropdown"
          labelId="mutiple-select-label"
          className={
            formik.values?.systemGeneratedId
              ? "form-select form-control select-user roles-dropdown-disabled"
              : "form-select form-control select-user roles-dropdown"
          }
          title={selected}
          multiple
          value={selected}
          onChange={handleChangeDropDown}
          renderValue={(roles) => {
            if (selected.length === 0) {
              return "Select Roles";
            }
            return roles.join(", ");
          }}
          MenuProps={MenuProps}
        >
          <MenuItem value="all">
            <ListItemIcon>
              <Checkbox
                checked={isAllSelected}
                indeterminate={
                  selected.length > 0 && selected.length < options.length
                }
              />
            </ListItemIcon>
            <ListItemText primary="Select All" />
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              <ListItemIcon>
                <Checkbox checked={selected.indexOf(option) > -1} />
              </ListItemIcon>
              <ListItemText primary={option} />
            </MenuItem>
          ))}
        </Select>
        <InlineMessage error={formik.errors.roles} />
      </div>
    );
  };

  const addNewSubscriptionFrequency = (index) => {
    let currentData = formik.values.distributorSubscriptionDomains;
    if (currentData && currentData.length > 0 && index < currentData.length) {
      const frequencyPlan = {
        baseValue: "",
        distributorSubscriptionPlanId: 0,
        distributorSubscriptionId: 0,
        uniqueId: getSecureRandomInt(1000),
        frequency: 0,
        effectiveFromDate: null,
        effectiveToDate: null,
        savedEffectiveToDate: null,
        isAssociated: false,
      };
      currentData[index].subscriptionPlan = [
        frequencyPlan,
        ...currentData[index].subscriptionPlan,
      ];
    }
    formik.setFieldValue("distributorSubscriptionDomains", currentData);
  };
  const addNewSubscription = () => {
    const addSubscriptionInitialValues = {
      distributorSubscriptionId: 0,
      uid: getSecureRandomInt(1000),
      name: "",
      status: 0,
      subscriptionPlan: [
        {
          baseValue: "",
          distributorSubscriptionPlanId: 0,
          distributorSubscriptionId: 0,
          uniqueId: getSecureRandomInt(1000),
          frequency: 0,
          effectiveFromDate: null,
          effectiveToDate: null,
          savedEffectiveToDate: null,
          isAssociated: false,
        },
      ],
    };
    let newData = [
      addSubscriptionInitialValues,
      ...formik.values.distributorSubscriptionDomains,
    ];
    formik.setFieldValue("distributorSubscriptionDomains", newData);
  };

  const handleSubscriptionChanges = (e, index, field, subIndex) => {
    if (subIndex === undefined) {
      // Case: Field belongs to distributorSubscriptionDomains directly
      formik.setFieldValue(
        `distributorSubscriptionDomains[${index}].${field}`,
        e?.target?.value
      );
      return;
    }

    // Case: Field belongs to nested subscriptionPlan array
    const isDateField = ["effectiveFromDate", "effectiveToDate"].includes(
      field
    );

    if (isDateField) {
      try {
        const d = e?._d || "";
        formik.setFieldValue(
          `distributorSubscriptionDomains[${index}].subscriptionPlan[${subIndex}].${field}`,
          d ? moment(d).format("YYYY-MM-DD") : null
        );
      } catch (error) {
        console.log("date error", error);
      }
    } else {
      forNormalSubPlanFields(field, formik, index, subIndex, e);
    }
  };

  const deleteSubscription = () => {
    let newList = formik.values.distributorSubscriptionDomains;
    const newSubPlanList = newList
      .find((item) => item.uid === selectedItem)
      .subscriptionPlan.filter((item) => item.uniqueId !== selectedSubItem);
    if (!newSubPlanList || newSubPlanList.length < 1) {
      newList = newList.filter((item) => item.uid !== selectedItem);
    } else {
      newList.map((el) => {
        if (el.uid === selectedItem) {
          el.subscriptionPlan = newSubPlanList;
        }
        return el;
      });
    }
    formik.setFieldValue("distributorSubscriptionDomains", newList);
    formik.setValues({
      ...formik.values,
      distributorSubscriptionDomains: newList,
    });
  };

  const getDateAlreadyExistsValidation = () => {
    let response = false;

    formik.values.distributorSubscriptionDomains?.every((item) => {
      item.subscriptionPlan?.every((subItem) => {
        let { minFromDate } = getMinFromAndToDate(item, subItem);

        let effFromDateRangeExists =
          !subItem.distributorSubscriptionPlanId > 0 &&
          subItem.effectiveFromDate &&
          new Date(
            subItem.effectiveFromDate
              .replaceAll("-", "/")
              .replaceAll(/T.+/g, "")
          ) <
          new Date(
            new Date(Math.max(minFromDate, new Date())).setHours(0, 0, 0, 0)
          );

        let effToDateRangeExists =
          !subItem.distributorSubscriptionPlanId > 0 &&
          subItem.effectiveToDate &&
          new Date(
            subItem.effectiveToDate.replaceAll("-", "/").replaceAll(/T.+/g, "")
          ) <
          new Date(
            new Date(Math.max(minFromDate, new Date())).setHours(0, 0, 0, 0)
          );
        if (effFromDateRangeExists || effToDateRangeExists) {
          response = true;
          return false;
        }
        return true;
      });

      return !response;
    });

    return response;
  };

  const isSubscriberType = useMemo(() => {
    return props?.routeData?.userTypeId === SystemUsersEnum.SUBSCRIBER;
  }, [props?.routeData?.userTypeId]);

  const renderDistSubscriptionItem = (item, index) => {
    let subPlans = applyFilterOnPlan(item, filterQuery);
    return hasSubPlans(subPlans) ? (
      <div
        style={{ paddingBottom: "5px" }}
        key={item.uid}
        className={`subscription${index}`}
      >
        <Grid container className="blue-field-section">
          <Grid item xs={3} p={1} className="inner-container">
            <label htmlFor="subscriptionName">Subscription Name</label>
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
            <input
              id="subscriptionName"
              name="subscriptionName"
              data-testid="subscriptionName"
              onChange={(e) => {
                formik.setFieldValue("dirty", true);
                handleSubscriptionChanges(e, index, "name");
              }}
              className="form-label form-control"
              type="text"
              value={formik.values.distributorSubscriptionDomains[index].name}
              placeholder="Enter Subscription Name"
              disabled={
                !isEditMode ||
                formik.values.distributorSubscriptionDomains[index]
                  .distributorSubscriptionId > 0
              }
              maxLength={50}
            />
            <InlineMessage error={NameValidationMessage(formik, index)} />
          </Grid>
        </Grid>
        <Grid container className="blue-field-section">
          <Grid
            item
            xs={2.75}
            pl={"10px"}
            className="base-value  currency-text"
          >
            <label htmlFor="baseValue">Base Value</label>
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          </Grid>
          <Grid item xs={2.75} pl={"10px"}>
            <label htmlFor="frequencyDropdown">Frequency</label>
            <MandatoryField />
          </Grid>
          <Grid
            item
            xs={2.75}
            className="blue-field-section date-picker-matui desktop-date-picker"
          >
            <label htmlFor="effectiveFromDate">Effective From Date</label>
            <MandatoryField />
          </Grid>
          <Grid
            item
            xs={2.75}
            pl={"10px"}
            className="blue-field-section date-picker-matui desktop-date-picker"
          >
            <label htmlFor="effectiveToDate">Effective To Date</label>
          </Grid>
        </Grid>
        {item.subscriptionPlan?.map((subItem, subIndex) => {
          let topIndex = item.subscriptionPlan.findIndex((x) =>
            addButtonIndex(filterQuery, x)
          );
          let { minFromDate, minToDate } = getMinFromAndToDate(item, subItem);
          let { effFromDateRangeExists, effToDateRangeExists } =
            effectiveDateRange(subItem, minFromDate);

          return subPlanValidation(filterQuery, subItem) ? (
            <div
              key={subItem.uniqueId}
              style={{ paddingBottom: "5px", paddingTop: "5px" }}
              className={activeInactiveGlobalClass(index, formik, subIndex)}
            >
              <Grid
                container
                className={activeInactiveGridClass(formik, index, subIndex)}
              >
                <Grid
                  item
                  xs={2.75}
                  pl={"10px"}
                  className="base-value currency-text"
                >
                  <CurrencyTextbox
                    id="baseValue"
                    name="baseValue"
                    value={
                      formik.values.distributorSubscriptionDomains[index]
                        ?.subscriptionPlan[subIndex]?.baseValue
                    }
                    onChange={(e) => {
                      setBaseValue(formik, index, subIndex, e, page);
                    }}
                    placeholder="Enter Base Value"
                    disabled={
                      !isEditMode ||
                      formik.values.distributorSubscriptionDomains[index]
                        .subscriptionPlan[subIndex]
                        .distributorSubscriptionPlanId > 0
                    }
                    data-testid="currency"
                    type="number"
                  />

                  <InlineMessage
                    error={baseValueValidation(formik, index, subIndex)}
                  />
                </Grid>

                <Grid item xs={2.75} pl={"10px"} pr={"10px"}>
                  <select
                    name="subscriptionFrequency"
                    id="subscriptionFrequency"
                    value={
                      formik.values.distributorSubscriptionDomains[index]
                        .subscriptionPlan[subIndex].frequency
                    }
                    onChange={(e) => {
                      formik.setFieldValue("dirty", true);
                      handleSubscriptionChanges(
                        e,
                        index,
                        "frequency",
                        subIndex
                      );
                    }}
                    className="form-control form-select"
                    disabled={
                      !isEditMode ||
                      formik.values.distributorSubscriptionDomains[index]
                        .subscriptionPlan[subIndex]
                        .distributorSubscriptionPlanId > 0
                    }
                  >
                    <option selected="true" disabled="true" value={0}>
                      Select Frequency
                    </option>
                    {getFrequencyOptions(frequencyOptions, item, subItem)}
                  </select>
                </Grid>
                <Grid
                  item
                  xs={2.75}
                  className="date-picker-matui desktop-date-picker"
                >
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                      minDate={new Date(Math.max(minFromDate, new Date()))}
                      disabled={
                        !isEditMode ||
                        formik.values.distributorSubscriptionDomains[index]
                          .subscriptionPlan[subIndex]
                          .distributorSubscriptionPlanId > 0 ||
                        !subItem.frequency > 0
                      }
                      className="form-label form-control date-field"
                      value={
                        formik.values.distributorSubscriptionDomains[index]
                          ?.subscriptionPlan[subIndex]?.effectiveFromDate ||
                        null
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleSubscriptionChanges(
                          e,
                          index,
                          "effectiveFromDate",
                          subIndex
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          id="effectiveFromDate"
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "MM/DD/YYYY",
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  {
                    <InlineMessage
                      error={getEFromDateValidationMessage(
                        formik,
                        index,
                        subIndex,
                        effFromDateRangeExists
                      )}
                    />
                  }
                </Grid>
                <Grid
                  item
                  xs={2.75}
                  pl={"10px"}
                  className="date-picker-matui desktop-date-picker"
                >
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                      minDate={new Date(Math.max(minToDate, new Date()))}
                      disabled={disableEToDate(isEditMode, subItem, item)}
                      className="form-label form-control date-field"
                      value={
                        formik.values.distributorSubscriptionDomains[index]
                          ?.subscriptionPlan[subIndex]?.effectiveToDate || null
                      }
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        handleSubscriptionChanges(
                          e,
                          index,
                          "effectiveToDate",
                          subIndex
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          id="effectiveToDate"
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "MM/DD/YYYY",
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  {
                    <InlineMessage
                      error={getEToDateValidationMessage(
                        formik,
                        index,
                        subIndex,
                        effToDateRangeExists
                      )}
                    />
                  }
                </Grid>

                <Grid
                  item
                  xs={1}
                  mt={-1}
                  className="add-association top-center-actions"
                >
                  {renderAddButton(
                    isEditMode,
                    subIndex,
                    topIndex,
                    addNewSubscriptionFrequency,
                    index
                  )}
                  {isEditMode && (
                    <Grid
                      style={{
                        paddingLeft: "6px",
                        paddingTop: "1px",
                        paddingRight: "20px",
                      }}
                    >
                      <IconButton
                        data-testid="btn-del"
                        disabled={subItem.isAssociated}
                        aria-label="delete"
                        color="primary"
                        onClick={() => {
                          handleEditModalCancelClick(item, subItem);
                        }}
                      >
                        {renderActiveInactiveDeleteButton(subItem)}
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </div>
          ) : null;
        })}
      </div>
    ) : null;
  };

  const onCancelHandler = () => {
    if (
      auth.getRole() === SystemUsersEnum.DISTRIBUTOR ||
      auth.getRole() === SystemUsersEnum.DISTRIBUTOR_INTERNAL
    ) {
      props.getEditData(formik.values.userId);
      setIsEditMode(false);
      handleCancelClick();
    } else if (
      props?.routeData?.userTypeId === 1 ||
      props?.routeData?.userTypeId === 2 ||
      props?.routeData?.userTypeId === 3 ||
      props?.routeData?.userTypeId === 7
    ) {
      handleCancelClick();
    } else {
      setIsEditMode(false);
    }
  };

  const onEditHandler = () => {
    setIsEditMode(true);
  };

  const getPlaceholder = (userTypeLabel) => {
    const placeholderMap = {
      "Distributors Type": "Select Distributors Type",
      "Subscriber Type": "Select Subscriber Type",
    };
    return placeholderMap[userTypeLabel] || "Select Type";
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    let ext = getFileExtension(selectedFile.name);
    ext = `image/${ext}`;
    if (!brandLogoAcceptedFormats.includes(ext.toLowerCase())) {
      e.target.value = null;
      toast.error(`Please select a valid file`);
      setLogo("");
      return;
    }
    setLogo(e.target.files[0]);
    const formData = new FormData();
    formData.append("File", selectedFile);
    showLoader(true);
    try {
      const response = await ApiServices.httpPostFile(UPLOAD_LOGO, formData);
      showLoader(false);
      if (response.responseStatus?.isSuccess) {
        formik.setFieldValue("logoGcpPath", response.result.gcpFilePath);
        formik.setFieldValue("logoGcpFileUrl", response.result.gcpFileUrl);
      } else {
        toast.error(response.responseStatus?.error);
      }
    } catch (err) {
      showLoader(false);
    }
  };
  const onDeleteFileHandler = () => {
    formik.setFieldValue("logoGcpPath", "");
    formik.setFieldValue("logoGcpFileUrl", "");
    setLogo("");
  };

  const getValueForField = (value, type) => {
    if (value?.length && value[0].label) {
      return value;
    } else if (value?.length && !value[0].label && type === "ent") {
      return getValueForEnterpriseGroupId(value);
    } else if (value?.length && !value[0].label && type === "dist") {
      return getValueForDistributorId(value);
    } else {
      return value;
    }
  };

  return (
    <>
      <Confirmation
        open={openConfirmation}
        title={deleteSubscriptionConfirmationMessage}
        cancelButtonLabel="No"
        confirmButtonLabel="Yes"
        onConfirm={() => {
          deleteSubscription();
          setOpenConfirmation(false);
        }}
        onCancel={() => {
          setOpenConfirmation(false);
        }}
      />

      {/* Basic Details Screen starts for distributors/subscribers */}
      {loadBasidDetails(basicDetailPermission, props) && (
        <Accordion
          className="accordion-ent"
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: "700" }}>Basic Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {" "}
            <div>
              <div className="modal-body" ref={myRef}>
                <Grid container spacing={2} className="blue-field-section">
                  {
                    <>
                      <Grid item xs={4} p={2} className="blue-field-section">
                        {renderMultiSelectRolesDropdown()}
                      </Grid>
                    </>
                  }

                  {props?.routeData?.userTypeId === 3 && (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="brandName">Brand Name</label>
                      <MandatoryField />
                      <input
                        id="brandName"
                        name="brandName"
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          formik.handleChange(e);
                          formik.setFieldValue("businessName", e.target.value);
                        }}
                        className="form-label form-control"
                        type="text"
                        maxLength={100}
                        placeholder="Enter Brand Name"
                        value={formik.values.brandName}
                        disabled={!isEditMode}
                      />
                      <InlineMessage error={formik.errors.brandName} />
                    </Grid>
                  )}

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="firstName">First Name</label>
                    <MandatoryField />
                    <input
                      id="firstName"
                      name="firstName"
                      onChange={(e) => handleFieldChange("firstName", e)}
                      className="form-label form-control"
                      type="text"
                      placeholder="Enter First Name"
                      value={formik.values.firstName}
                      disabled={!isEditMode}
                      maxLength={25}
                    />
                    <InlineMessage error={formik.errors.firstName} />
                  </Grid>

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="lastName">Last Name</label>
                    <MandatoryField />
                    <input
                      id="lastName"
                      name="lastName"
                      onChange={(e) => handleFieldChanges("lastName", e)}
                      value={formik.values.lastName}
                      className="form-label form-control"
                      type="text"
                      placeholder="Enter Last Name"
                      disabled={!isEditMode}
                      maxLength={25}
                    />
                    <InlineMessage error={formik.errors.lastName} />
                  </Grid>

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="distributorType">
                      {props.routeData?.userTypeLabel}
                    </label>
                    <MandatoryField />
                    <MultiSelectDropDown
                      name="distributorType"
                      id="distributorType"
                      value={formik.values.distributorType}
                      onChange={(value) => {
                        formik.setValues({
                          ...formik.values,
                          distributorType: value,
                          dirty: true,
                        });
                      }}
                      options={distributorTypeOptions}
                      disabled={!isEditMode}
                      placeholder={getPlaceholder(
                        props.routeData?.userTypeLabel
                      )}
                    />
                    <InlineMessage
                      error={
                        formik.errors.distributorType &&
                        props?.routeData?.distTypeError
                      }
                    />
                  </Grid>

                  {entBrandNameSection()}
                  {distBrandNameSection()}

                  {primaryEmailAdmin(
                    auth,
                    isEditMode,
                    editMode,
                    formik,
                    handleEditClick
                  )}
                  {props?.routeData?.userTypeId === 3 && (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label
                        htmlFor="application"
                        className="file-upload-label"
                      >
                        <span>Logo </span>
                        {getLogoText(logo, formik)}
                      </label>
                      <FileUploader
                        accept={brandLogoAcceptedFormats}
                        onSelectFile={handleFileChange}
                        onDeleteFile={onDeleteFileHandler}
                        maxSizeInBytes={maxSizeInBytes}
                        maxSizeExeedError={maxSizeExeedError}
                        disabled={!isEditMode}
                        sourceFile={logo}
                      />
                      {formik.values.logoGcpPath !== "" && (
                        <div>{formik.values.logoGcpPath}</div>
                      )}
                    </Grid>
                  )}

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="secondaryEmail">
                      Secondary Email Address
                    </label>
                    <input
                      id="secondaryEmail"
                      name="secondaryEmail"
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        formik.handleChange(e);
                      }}
                      value={formik.values.secondaryEmail}
                      className="form-label form-control"
                      type="text"
                      placeholder="Enter Secondary Email Address"
                      disabled={!isEditMode}
                    />
                    <InlineMessage error={formik.errors.secondaryEmail} />
                  </Grid>

                  {props?.routeData?.userTypeId === 3 && (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="carriers">Carrier</label>
                      <MultiSelectDropDown
                        id="carriers"
                        name="carriers"
                        value={formik.values.carriers}
                        isClearable={() => setViewForm(!viewForm)}
                        menuShouldBlockScroll
                        isMulti
                        options={carrier}
                        onChange={(value) => {
                          formik.setValues({
                            ...formik.values,
                            carriers: value,
                            dirty: true,
                          });
                        }}
                        disabled={!isEditMode}
                        placeholder="Select Carrier"
                      />
                    </Grid>
                  )}

                  {["agent", "all"].includes(type) && (
                    <>
                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="carrierRepresents">
                          Carriers Represented
                        </label>

                        <MultiSelectDropDown
                          id="carrierRepresents"
                          name="carrierRepresents"
                          value={formik.values.carrierRepresents}
                          isClearable={() => setViewForm(!viewForm)}
                          menuShouldBlockScroll
                          isMulti
                          options={career}
                          onChange={(value) => {
                            formik.setValues({
                              ...formik.values,
                              carrierRepresents: value,
                              dirty: true,
                            });
                          }}
                          disabled={!isEditMode}
                          placeholder="Select Carriers Represented"
                        />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="areas">Major Areas</label>
                        <MultiSelectDropDown
                          id="areas"
                          name="areas"
                          value={formik.values.areas}
                          isMulti
                          options={areaOptions}
                          onChange={(value) => {
                            formik.setValues({
                              ...formik.values,
                              areas: value,
                              dirty: true,
                            });
                          }}
                          disabled={!isEditMode}
                          placeholder="Select Major Areas"
                        />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="producers">Number of Producers</label>
                        <input
                          id="producers"
                          name="producers"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          value={formik.values.producers}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Number of Producers"
                          disabled={!isEditMode}
                        />
                        <InlineMessage error={formik.errors.producers} />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="industryGroups">
                          Industry Groups/ Membership
                        </label>
                        <MultiSelectDropDown
                          id="industryGroups"
                          name="industryGroups"
                          value={formik.values.industryGroups}
                          isMulti
                          options={industry}
                          onChange={(value) => {
                            formik.setValues({
                              ...formik.values,
                              industryGroups: value,
                              dirty: true,
                            });
                          }}
                          disabled={!isEditMode}
                          placeholder="Select Industry Groups/ Membership"
                        />
                      </Grid>
                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="technologies">
                          Technology being used now
                        </label>
                        <MultiSelectDropDown
                          id="technologies"
                          name="technologies"
                          value={formik.values.technologies}
                          isMulti
                          options={technology}
                          onChange={(value) => {
                            formik.setValues({
                              ...formik.values,
                              technologies: value,
                              dirty: true,
                            });
                          }}
                          disabled={!isEditMode}
                          placeholder="Select Technology being used now"
                        />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="businessYear">Years in Business</label>
                        <input
                          id="businessYear"
                          name="businessYear"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          value={formik.values.businessYear}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Years in Business"
                          disabled={!isEditMode}
                        />
                        <InlineMessage error={formik.errors.businessYear} />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="websiteUrl">Website URL</label>
                        <input
                          id="websiteUrl"
                          name="websiteUrl"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          value={formik.values.websiteUrl}
                          className="form-label form-control"
                          type="url"
                          placeholder="Enter Website URL"
                          disabled={!isEditMode}
                        />
                        <InlineMessage error={formik.errors.websiteUrl} />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="annualRevenue">Annual Revenue</label>
                        <select
                          id="annualRevenue"
                          name="annualRevenue"
                          value={formik.values.annualRevenue}
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          className="form-control form-select"
                          disabled={!isEditMode}
                        >
                          <option value="0">Select Annual Revenue</option>
                          {annualRevenues?.map((res) => {
                            return (
                              <option
                                key={res.annualRevenueId}
                                value={res.annualRevenueId}
                              >
                                {res.name}
                              </option>
                            );
                          })}
                        </select>
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="numberOfEmployees">
                          Number of Employees
                        </label>
                        <select
                          id="numberOfEmployees"
                          name="numberOfEmployees"
                          value={formik.values.numberOfEmployees}
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          className="form-control form-select"
                          disabled={!isEditMode}
                        >
                          <option value="0">Select Number of Employees</option>
                          {numberOfEmployees?.map((res) => {
                            return (
                              <option key={res.label} value={res.value}>
                                {res.value}
                              </option>
                            );
                          })}
                        </select>
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="numberOfOwners">
                          Number of Principals / Owners
                        </label>
                        <input
                          id="numberOfOwners"
                          name="numberOfOwners"
                          value={formik.values.numberOfOwners}
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Number of Principals / Owners"
                          disabled={!isEditMode}
                        />
                        <InlineMessage error={formik.errors.numberOfOwners} />
                      </Grid>
                    </>
                  )}

                  {type === "other" && (
                    <>
                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="busineesYear">Years in Business </label>
                        <input
                          id="businessYear"
                          name="businessYear"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          value={formik.values.businessYear}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Years in Business"
                          disabled={!isEditMode}
                        />
                        <InlineMessage error={formik.errors.businessYear} />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="websiteUrl">Website URL</label>
                        <input
                          id="websiteUrl"
                          value={formik.values.websiteUrl}
                          name="websiteUrl"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Website URL"
                          disabled={!isEditMode}
                        />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="annualRevenue">Annual Revenue</label>
                        <select
                          id="annualRevenue"
                          name="annualRevenue"
                          value={formik.values.annualRevenue}
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          className="form-control form-select"
                          disabled={!isEditMode}
                        >
                          <option value="0">Select Annual Revenue</option>
                          {annualRevenues?.map((res) => {
                            return (
                              <option
                                key={res.annualRevenueId}
                                value={res.annualRevenueId}
                              >
                                {res.name}
                              </option>
                            );
                          })}
                        </select>
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="numberOfEmployees">
                          Number of Employees
                        </label>
                        <select
                          id="numberOfEmployees"
                          name="numberOfEmployees"
                          value={formik.values.numberOfEmployees}
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          className="form-control form-select"
                          disabled={!isEditMode}
                        >
                          <option value="0">Select Number of Employees</option>
                          {numberOfEmployees?.map((res) => {
                            return (
                              <option key={res.label} value={res.value}>
                                {res.value}
                              </option>
                            );
                          })}
                        </select>
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="numberOfOwners">
                          Number of Principals / Owners
                        </label>
                        <input
                          id="numberOfOwners"
                          name="numberOfOwners"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          value={formik.values.numberOfOwners}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Number of Principals / Owners"
                          disabled={!isEditMode}
                        />
                        <InlineMessage error={formik.errors.numberOfOwners} />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="industryGroups">
                          Industry Groups/ Membership
                        </label>
                        <MultiSelectDropDown
                          id="industryGroups"
                          name="industryGroups"
                          value={formik.values.industryGroups}
                          isMulti
                          options={industry}
                          onChange={(value) => {
                            formik.setValues({
                              ...formik.values,
                              industryGroups: value,
                              dirty: true,
                            });
                          }}
                          disabled={!isEditMode}
                          placeholder="Select Industry Groups/ Membership"
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="phoneNumber">
                      {isSubscriberType ? "Business Phone Number " : "Phone Number"}
                    </label>
                    <MandatoryField />
                    <BusinessPhoneNumberTextbox
                      id="phoneNumber"
                      className="form-label form-control"
                      name="phoneNumber"
                      placeholder={isSubscriberType ? "Enter Business Phone Number" : "Enter Phone Number"}
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        formik.setFieldValue("phoneNumber", e);
                      }}
                      value={formik.values.phoneNumber}
                      disabled={!isEditMode}
                      phoneCode={getPhoneCode(
                        countryOptions,
                        formik.values.countryId
                      )}
                    />
                    <InlineMessage error={formik.errors.phoneNumber} />
                  </Grid>
                  {secNumberMissingSection()}

                  {secNumberExistSection()}

                  {props.routeData.addRoute === "/subscriber" ? null : (
                    <>
                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="businessName">Business Name</label>
                        <input
                          id="businessName"
                          name="businessName"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          value={formik?.values?.businessName}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Business Name"
                          disabled={!isEditMode}
                        />
                      </Grid>

                      <Grid item xs={4} p={2} className="blue-field-section">
                        <label htmlFor="taxID">Tax Id</label>
                        <input
                          id="taxID"
                          name="taxID"
                          onChange={(e) => {
                            formik.setFieldValue("dirty", true);
                            formik.handleChange(e);
                          }}
                          value={formik?.values?.taxID}
                          className="form-label form-control"
                          type="text"
                          placeholder="Enter Tax ID"
                          disabled={!isEditMode}
                        />
                        <InlineMessage error={formik.errors.taxID} />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="mobile">{isSubscriberType ? "Mobile Phone Number " : "Mobile"}</label>
                    <PhoneNumberTextbox
                      id="mobile"
                      className="form-label form-control"
                      name="mobile"
                      placeholder={isSubscriberType ? "Enter Mobile Phone Number" : "Enter Mobile Number"}
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        formik.handleChange(e);
                      }}
                      value={formik.values.mobile}
                      disabled={!isEditMode}
                      phoneCode={getPhoneCode(
                        countryOptions,
                        formik.values.countryId
                      )}
                    />
                    <InlineMessage error={formik.errors.mobile} />
                  </Grid>
                  <SMSConcentCheckBox
                    isSubscriberType={isSubscriberType}
                    isEditMode={isEditMode}
                    isSmsConsentGiven={formik.values.isSmsConsentGiven}
                    onSmsConsentChange={(checked) => {
                      formik.setFieldValue("isSmsConsentGiven", checked);
                      formik.setFieldValue("dirty", true);
                    }}
                  />

                  {anotherMobileMissingsection()}

                  {anotherMobileExistSection()}

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="fax">Fax</label>
                    <PhoneNumberTextbox
                      id="fax"
                      className="form-label form-control"
                      name="fax"
                      placeholder="Enter Fax"
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        formik.handleChange(e);
                      }}
                      value={formik.values.fax}
                      disabled={!isEditMode}
                      phoneCode={getPhoneCode(
                        countryOptions,
                        formik.values.countryId
                      )}
                    />
                    <InlineMessage error={formik.errors.fax} />
                  </Grid>

                  {altFaxMissingSection()}

                  {altFaxExistSection()}

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="billingContact">Billing First Name</label>
                    <input
                      id="billingContact"
                      name="billingContact"
                      onChange={(e) => handleFieldChange("billingContact", e)}
                      value={formik.values.billingContact}
                      className="form-label form-control"
                      type="text"
                      placeholder="Enter Billing First Name"
                      disabled={!isEditMode}
                    />
                  </Grid>

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="billingContactLastName">
                      Billing Last Name{" "}
                    </label>
                    <input
                      id="billingContactLastName"
                      name="billingContactLastName"
                      onChange={(e) =>
                        handleFieldChange("billingContactLastName", e)
                      }
                      value={formik.values.billingContactLastName}
                      className="form-label form-control"
                      type="text"
                      placeholder="Enter Billing Last Name"
                      disabled={!isEditMode}
                    />
                  </Grid>

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="billingPhoneNumber">
                      Billing Phone Number
                    </label>
                    <PhoneNumberTextbox
                      id="billingPhoneNumber"
                      className="form-label form-control"
                      name="billingPhoneNumber"
                      placeholder="Enter Billing Phone Number"
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        formik.handleChange(e);
                      }}
                      value={formik.values.billingPhoneNumber}
                      disabled={!isEditMode}
                      phoneCode={getPhoneCode(
                        countryOptions,
                        formik.values.countryId
                      )}
                    />
                    <InlineMessage error={formik.errors.billingPhoneNumber} />
                  </Grid>

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="billingAddressLine1">
                      Billing Address Line 1
                    </label>
                    <input
                      id="billingAddressLine1"
                      name="billingAddressLine1"
                      value={formik.values.billingAddressLine1}
                      className="form-label form-control"
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        formik.handleChange(e);
                      }}
                      type="text"
                      placeholder="Enter Billing Address Line 1 "
                      disabled={!isEditMode}
                    />
                  </Grid>

                  <Grid item xs={4} p={2} className="blue-field-section">
                    <label htmlFor="billingAddressLine2">
                      Billing Address Line 2
                    </label>
                    <input
                      id="billingAddressLine2"
                      name="billingAddressLine2"
                      value={formik.values.billingAddressLine2}
                      onChange={(e) => {
                        formik.setFieldValue("dirty", true);
                        formik.handleChange(e);
                      }}
                      className="form-label form-control"
                      type="text"
                      placeholder="Enter Billing Address Line 2"
                      disabled={!isEditMode}
                    />
                  </Grid>
                  {props.routeData?.userTypeId === 7 ? (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="countryId">Billing Country</label>
                      <select
                        id="countryId"
                        name="countryId"
                        value={formik.values?.countryId}
                        onChange={(e) => {
                          formik.setValues({
                            ...formik.values,
                            dirty: true,
                            stateId: null,
                            countryId: Number(e.target.value),
                          });
                        }}
                        className="form-control form-select"
                        disabled={!isEditMode}
                      >
                        {countryOptions?.map((res) => {
                          return (
                            <option key={res.countryId} value={res.countryId}>
                              {res.name}
                            </option>
                          );
                        })}
                      </select>
                    </Grid>
                  ) : (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="countryId">Country</label>
                      <select
                        id="countryId"
                        name="countryId"
                        value={formik.values?.countryId}
                        onChange={(e) => {
                          formik.setValues({
                            ...formik.values,
                            dirty: true,
                            stateId: null,
                            countryId: Number(e.target.value),
                          });
                        }}
                        className="form-control form-select"
                        disabled={!isEditMode}
                      >
                        {countryOptions?.map((res) => {
                          return (
                            <option key={res.countryId} value={res.countryId}>
                              {res.name}
                            </option>
                          );
                        })}
                      </select>
                    </Grid>
                  )}
                  {props.routeData?.userTypeId === 7 ? (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="stateId">Billing State</label>
                      <select
                        id="stateId"
                        name="stateId"
                        value={formik.values.stateId}
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          formik.handleChange(e);
                        }}
                        className="form-label form-control"
                        type="text"
                        placeholder="Enter State"
                        disabled={!isEditMode}
                      >
                        <option>Select State</option>
                        {stateOptions?.map((res) => {
                          return (
                            <option key={res.stateId} value={res.stateId}>
                              {res.name}
                            </option>
                          );
                        })}
                      </select>
                    </Grid>
                  ) : (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="stateId">State</label>
                      <select
                        id="stateId"
                        name="stateId"
                        value={formik.values.stateId}
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          formik.handleChange(e);
                        }}
                        className="form-label form-control"
                        type="text"
                        placeholder="Enter State"
                        disabled={!isEditMode}
                      >
                        <option>Select State</option>
                        {stateOptions?.map((res) => {
                          return (
                            <option key={res.stateId} value={res.stateId}>
                              {res.name}
                            </option>
                          );
                        })}
                      </select>
                    </Grid>
                  )}
                  {props.routeData?.userTypeId === 7 ? (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="city">Billing City</label>
                      <input
                        name="city"
                        id="city"
                        value={formik.values.city}
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          formik.handleChange(e);
                        }}
                        className="form-label form-control"
                        type="text"
                        placeholder="Enter Billing City"
                        disabled={!isEditMode}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="city"> City</label>
                      <input
                        name="city"
                        id="city"
                        value={formik.values.city}
                        onChange={(e) => {
                          formik.setFieldValue("dirty", true);
                          formik.handleChange(e);
                        }}
                        className="form-label form-control"
                        type="text"
                        placeholder="Enter City"
                        disabled={!isEditMode}
                      />
                    </Grid>
                  )}

                  {props.routeData?.userTypeId === 7 ? (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="zip">
                        {getZipLabel(formik.values.countryId)}
                      </label>
                      <input
                        id="zip"
                        name="zip"
                        className="form-label form-control"
                        type="text"
                        maxLength={getMaxLength(formik.values.countryId)}
                        placeholder={getZipPlaceholder(formik.values.countryId)}
                        value={formik.values.zip}
                        onChange={(e) => handleZipChange(e, formik)}
                        disabled={!isEditMode}
                      />
                      <InlineMessage error={formik.errors.zip} />
                    </Grid>
                  ) : (
                    <Grid item xs={4} p={2} className="blue-field-section">
                      <label htmlFor="zip">
                        {getBillingZipLabel(formik.values.countryId)}
                      </label>
                      <input
                        id="zip"
                        name="zip"
                        className="form-label form-control"
                        type="text"
                        maxLength={getMaxLength(formik.values.countryId)}
                        placeholder={getBillingZipPlaceholder(
                          formik.values.countryId
                        )}
                        value={formik.values.zip}
                        onChange={(e) => handleZipChange(e, formik)}
                        disabled={!isEditMode}
                      />
                      <InlineMessage error={formik.errors.zip} />
                    </Grid>
                  )}
                  {props.routeData?.userTypeId === 7 && (
                    <Grid
                      item
                      xs={4}
                      p={2}
                      className="blue-field-section"
                      style={{ marginTop: "27px" }}
                    >
                      <FormControlLabel
                        className="shipping-same-billing"
                        componentsProps={{ label: { style: { flex: 1 } } }}
                        control={
                          <Checkbox
                            checked={
                              formik.values.isShippingAddressSameAsBilling
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              formik.setFieldValue(
                                "isShippingAddressSameAsBilling",
                                checked
                              );
                              formik.setFieldValue("dirty", true);

                              if (checked) {
                                // Copy billing -> shipping
                                formik.setValues({
                                  ...formik.values,
                                  isShippingAddressSameAsBilling: true,
                                  shippingContactName:
                                    formik.values.billingContact || "",
                                  shippingContactLastName:
                                    formik.values.billingContactLastName || "",
                                  shippingPhoneNumber:
                                    formik.values.billingPhoneNumber || "",
                                  shippingAddressLine1:
                                    formik.values.billingAddressLine1 || "",
                                  shippingAddressLine2:
                                    formik.values.billingAddressLine2 || "",
                                  shippingCountryId:
                                    formik.values.countryId || null,
                                  shippingStateId:
                                    formik.values.stateId || null,
                                  shippingCity: formik.values.city || "",
                                  shippingZipCode: formik.values.zip || "",
                                });
                              } else {
                                // Clear shipping fields
                                formik.setValues({
                                  ...formik.values,
                                  isShippingAddressSameAsBilling: false,
                                  shippingContactName: "",
                                  shippingContactLastName: "",
                                  shippingPhoneNumber: "",
                                  shippingAddressLine1: "",
                                  shippingAddressLine2: "",
                                  shippingCountryId: null,
                                  shippingStateId: null,
                                  shippingCity: "",
                                  shippingZipCode: "",
                                });
                              }
                            }}
                            disabled={!isEditMode}
                            sx={{ p: 0, mr: 1 }}
                          />
                        }
                        label="Use shipping Details same as billing Details"
                        sx={{
                          m: 0,
                          width: "100%",
                          alignItems: "center",
                          "&.Mui-disabled": { m: 0 },
                        }}
                      />
                    </Grid>
                  )}
                  {props.routeData?.userTypeId === 7 &&
                    !isShippingAddressSameAsBilling && (
                      <>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingContactName">
                            Shipping First Name
                          </label>
                          <input
                            id="shippingContactName"
                            name="shippingContactName"
                            className="form-label form-control"
                            type="text"
                            value={formik.values.shippingContactName}
                            placeholder="Enter Shipping First Name"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "shippingContactName",
                                e.target.value
                              )
                            }
                            disabled={!isEditMode}
                            maxLength={25}
                          />
                          <InlineMessage
                            error={formik.errors.shippingContactName}
                          />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingContactLastName">
                            Shipping Last Name
                          </label>
                          <input
                            id="shippingContactLastName"
                            name="shippingContactLastName"
                            className="form-label form-control"
                            type="text"
                            value={formik.values.shippingContactLastName}
                            placeholder="Enter Shipping Last Name"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "shippingContactLastName",
                                e.target.value
                              )
                            }
                            disabled={!isEditMode}
                            maxLength={25}
                          />
                          <InlineMessage
                            error={formik.errors.shippingContactLastName}
                          />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingPhoneNumber">
                            Shipping Phone Number
                          </label>
                          <PhoneNumberTextbox
                            id="shippingPhoneNumber"
                            className="form-label form-control"
                            name="shippingPhoneNumber"
                            placeholder="Enter Shipping Phone Number"
                            onChange={(e) => {
                              formik.setFieldValue("dirty", true);
                              formik.handleChange(e);
                            }}
                            value={formik.values.shippingPhoneNumber}
                            disabled={!isEditMode}
                            phoneCode={getPhoneCode(
                              countryOptions,
                              formik.values.countryId
                            )}
                          />
                          <InlineMessage
                            error={formik.errors.shippingPhoneNumber}
                          />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingAddressLine1">
                            Shipping Address Line 1
                          </label>
                          <input
                            id="shippingAddressLine1"
                            name="shippingAddressLine1"
                            className="form-label form-control"
                            type="text"
                            value={formik.values.shippingAddressLine1}
                            placeholder="Enter Shipping Address Line 1"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "shippingAddressLine1",
                                e.target.value
                              )
                            }
                            disabled={!isEditMode}
                          />
                          <InlineMessage
                            error={formik.errors.shippingAddressLine1}
                          />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingAddressLine2">
                            Shipping Address Line 2
                          </label>
                          <input
                            id="shippingAddressLine2"
                            name="shippingAddressLine2"
                            className="form-label form-control"
                            type="text"
                            value={formik.values.shippingAddressLine2}
                            placeholder="Enter Shipping Address Line 2"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "shippingAddressLine2",
                                e.target.value
                              )
                            }
                            disabled={!isEditMode}
                          />
                          <InlineMessage
                            error={formik.errors.shippingAddressLine2}
                          />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingCountryId">
                            Shipping Country
                          </label>
                          <select
                            id="shippingCountryId"
                            name="shippingCountryId"
                            className="form-control form-select"
                            value={formik.values.shippingCountryId || ""}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "shippingCountryId",
                                Number(e.target.value)
                              );
                              formik.setFieldValue("shippingStateId", null);
                              formik.setFieldValue("shippingZipCode", null);
                            }}
                            disabled={!isEditMode}
                          >
                            <option value="">Select Country</option>
                            {countryOptions?.map((res) => (
                              <option key={res.countryId} value={res.countryId}>
                                {res.name}
                              </option>
                            ))}
                          </select>
                          <InlineMessage
                            error={formik.errors.shippingCountryId}
                          />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingStateId">
                            Shipping State
                          </label>
                          <select
                            id="shippingStateId"
                            name="shippingStateId"
                            className="form-control form-select"
                            value={formik.values.shippingStateId || ""}
                            onChange={(e) =>
                              formik.setFieldValue(
                                "shippingStateId",
                                Number(e.target.value)
                              )
                            }
                            disabled={!isEditMode}
                          >
                            <option value="">Select State</option>
                            {shippingStateOptions?.map((res) => (
                              <option key={res.stateId} value={res.stateId}>
                                {res.name}
                              </option>
                            ))}
                          </select>
                          <InlineMessage
                            error={formik.errors.shippingStateId}
                          />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingCity">Shipping City</label>
                          <input
                            id="shippingCity"
                            name="shippingCity"
                            className="form-label form-control"
                            type="text"
                            value={formik.values.shippingCity}
                            placeholder="Enter Shipping City"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "shippingCity",
                                e.target.value
                              )
                            }
                            disabled={!isEditMode}
                          />
                          <InlineMessage error={formik.errors.shippingCity} />
                        </Grid>
                        <Grid item xs={4} p={2} className="blue-field-section">
                          <label htmlFor="shippingZip">
                            {getShippingZipLabel(
                              formik.values.shippingCountryId ||
                              formik.values.countryId
                            ).replace(
                              /Zip Code|Postal Code/i,
                              (m) => `Shipping ${m}`
                            )}
                          </label>
                          <input
                            id="shippingZipCode"
                            name="shippingZipCode"
                            className="form-label form-control"
                            type="text"
                            maxLength={getMaxLength(
                              formik.values.shippingCountryId
                            )}
                            placeholder={getShippingZipPlaceholder(
                              formik.values.shippingCountryId ||
                              formik.values.countryId
                            )}
                            value={formik.values.shippingZipCode}
                            onChange={handleShippingZipChange}
                            disabled={!isEditMode}
                          />
                          <InlineMessage
                            error={formik.errors.shippingZipCode}
                          />
                        </Grid>
                      </>
                    )}
                </Grid>
              </div>
            </div>
            <FooterButtons
              isEditMode={isEditMode}
              permissions={permissions}
              permissionId={permissionId}
              editPermission={editPermissionBasic}
              showUpdateNext={
                formik.values.userId > 0 && props?.routeData?.userTypeId !== 7
              }
              showSaveNext={
                !formik.values.userId && props?.routeData?.userTypeId !== 7
              }
              disableUpdateNext={
                !isEditMode ||
                !formik.isValid ||
                getDateAlreadyExistsValidation()
              }
              disableSaveNext={
                !isEditMode ||
                !formik.isValid ||
                getDateAlreadyExistsValidation()
              }
              showUpdateDetail={formik.values.userId > 0}
              disableUpdateDetail={
                !isEditMode ||
                Object.keys(formik.errors).length > 0 ||
                getDateAlreadyExistsValidation()
              }
              disableSaveDetail={
                !isEditMode ||
                !formik.isValid ||
                getDateAlreadyExistsValidation()
              }
              onCancel={onCancelHandler}
              onEdit={onEditHandler}
              onUpdateNext={() => updateDistributor(true)}
              onSaveNext={() => {
                createDistributor(true);
              }}
              onUpdate={() => updateDistributor(false)}
              onSave={() => {
                createDistributor(false);
              }}
            />
          </AccordionDetails>
        </Accordion>
      )}
      {/* Basic Details Screen ends*/}

      {/* association Details Screen starts for distributors */}
      {associationDetailsPermission.includes(PermissionEnum.LIST) &&
        props.routeData.userTypeId === 3 &&
        !hidden && (
          <Accordion
            className="accordion-ent"
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography sx={{ fontWeight: "700" }}>
                Association Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2} className="blue-field-section">
                <Grid item sx={4} p={2} className="serachable-dropdown">
                  <label htmlFor="enterpriseGroupIdDropdown">
                    Parent Distributor (if any)
                  </label>
                  <SearchableDropDown
                    isEditMode={isEditMode}
                    options={parentDropdown.map((res) => {
                      return {
                        label: res.name,
                        id: res.userId,
                      };
                    })}
                    name="enterpriseGroupIdDropdown"
                    id="enterpriseGroupIdDropdown"
                    setData={(value) => {
                      setMembership(value.id ? `INCHANTED_${value.id}` : "");
                      setSelectedValue([value]);
                      formik.setValues({
                        ...formik.values,
                        parentUser: {
                          ...formik.values.parentUser,
                          parentUserId: value.id,
                          dirty: true,
                        },
                      });
                    }}
                    value={selectedValue}
                    placeholder="Select Parent Distributor"
                    disabled={!isEditMode}
                  />
                </Grid>
                {selectedValue !== null && (
                  <Grid item sx={4} p={2}>
                    <label htmlFor="enterpriseGroupIdDropdown">
                      Membership ID
                    </label>
                    <input
                      disabled
                      id="membershipId"
                      name="membershipId"
                      className="form-label form-control"
                      type="text"
                      placeholder="Enter Membership ID"
                      value={memberShip}
                    />
                  </Grid>
                )}
              </Grid>
              {selectedValue !== null && (
                <div className="blue-field-section">
                  <div className="add-association blue-field-section">
                    Section Access to Parent Distributor
                  </div>
                  <Grid
                    container
                    spacing={2}
                    className="permission-list blue-field-section"
                  >
                    {permissionList.map((res, index) => {
                      return (
                        <Grid
                          item
                          md={12}
                          p={2}
                          key={res.parentPermissionMasterId}
                        >
                          <Typography className="basic-information">
                            {res.name}
                          </Typography>
                          <div>
                            <Checkbox
                              checked={
                                formik.values.parentUser?.permissions[index]
                                  ?.isRead
                              }
                              onChange={(e) => {
                                formik.setFieldValue("dirty", true);
                                permissionChange(
                                  index,
                                  res.parentPermissionMasterId,
                                  "isRead"
                                );
                              }}
                              disabled={!isEditMode}
                            />
                            Read
                            <Checkbox
                              checked={
                                formik.values.parentUser?.permissions[index]
                                  ?.isWrite
                              }
                              onChange={(e) => {
                                formik.setFieldValue("dirty", true);
                                permissionChange(
                                  index,
                                  res.parentPermissionMasterId,
                                  "isWrite"
                                );
                              }}
                              disabled={!isEditMode}
                            />
                            Write
                            <Checkbox
                              checked={
                                formik.values.parentUser?.permissions[index]
                                  ?.isNoAccess
                              }
                              onChange={(e) => {
                                formik.setFieldValue("dirty", true);
                                permissionChange(
                                  index,
                                  res.parentPermissionMasterId,
                                  "isNoAccess"
                                );
                              }}
                              disabled={!isEditMode}
                            />
                            No Access <br></br>
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                </div>
              )}
              <FooterButtons
                isEditMode={isEditMode}
                permissions={permissions}
                permissionId={permissionId}
                editPermission={editPermissionAssociation}
                showUpdateNext={
                  formik.values.userId > 0 && props?.routeData?.userTypeId !== 7
                }
                showSaveNext={
                  !formik.values.userId && props?.routeData?.userTypeId !== 7
                }
                disableUpdateNext={
                  !isEditMode ||
                  !formik.isValid ||
                  getDateAlreadyExistsValidation()
                }
                disableSaveNext={
                  !isEditMode ||
                  !formik.isValid ||
                  getDateAlreadyExistsValidation()
                }
                showUpdateDetail={formik.values.userId > 0}
                disableUpdateDetail={
                  !isEditMode ||
                  !formik.isValid ||
                  getDateAlreadyExistsValidation()
                }
                disableSaveDetail={
                  !isEditMode ||
                  !formik.isValid ||
                  getDateAlreadyExistsValidation()
                }
                onCancel={onCancelHandler}
                onEdit={onEditHandler}
                onUpdateNext={() => updateDistributor(true)}
                onSaveNext={() => {
                  createDistributor(true);
                }}
                onUpdate={() => {
                  updateDistributor(false);
                }}
                onSave={() => {
                  createDistributor(false);
                }}
              />
            </AccordionDetails>
          </Accordion>
        )}
      {/* Association Details Screen ends */}

      {/*  Subscription Details Screen starts for distributors */}
      {subscriptionDetailsPermission?.includes(PermissionEnum.LIST) &&
        props.routeData.userTypeId === 3 && (
          <Accordion
            className="accordion-ent"
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3a-content"
              id="panel3a-header"
            >
              <Typography sx={{ fontWeight: "700" }}>
                Subscription Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {
                <Grid container spacing={2} className="blue-field-section">
                  {isEditMode && (
                    <Grid item sx={12} p={2}>
                      <Typography className="add-association">
                        Add the subscriptions you offer.
                        <Tooltip placement="bottom" title="Add">
                          <AddOutlinedIcon
                            name="add-icon"
                            title="add-icon"
                            onClick={() => {
                              addNewSubscription();
                            }}
                          />
                        </Tooltip>
                      </Typography>
                    </Grid>
                  )}
                  {formik.values.distributorSubscriptionDomains &&
                    formik.values.distributorSubscriptionDomains.length > 0 && (
                      <Grid item className="top-right-actions" xs={12}>
                        <div
                          style={{ paddingTop: "10px" }}
                          className="add-welcome-widgets-content"
                        >
                          <Popover
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            id={"simple-popover"}
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={() => {
                              handleClose();
                            }}
                          >
                            <div className="expanded-filter">
                              <div className="filter-options">
                                <List
                                  sx={{
                                    width: "100%",
                                    maxWidth: 360,
                                    bgcolor: "background.paper",
                                  }}
                                  component="nav"
                                  aria-labelledby="nested-list-subheader"
                                  subheader={
                                    <ListSubheader
                                      component="div"
                                      id="nested-list-subheader"
                                    >
                                      Filters will be applied to your grid
                                    </ListSubheader>
                                  }
                                >
                                  <Accordion
                                    expanded={expandedFilter === "status"}
                                    onChange={filterAccordianHandleChange(
                                      "status"
                                    )}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={{ flexShrink: 0 }}>
                                        Status
                                      </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <CheckboxList
                                        id="status"
                                        options={subscriptionStatusFilters}
                                        onChange={onFilterStatusChangeHandler}
                                        selectedValues={selectedStatus}
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion
                                    expanded={expandedFilter === "frequency"}
                                    onChange={filterAccordianHandleChange(
                                      "frequency"
                                    )}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={{ flexShrink: 0 }}>
                                        Frequency
                                      </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <CheckboxList
                                        id="frequency"
                                        options={frequencyOptions}
                                        onChange={onFilterFreqChangeHandler}
                                        selectedValues={selectedFreq}
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                </List>
                              </div>
                              <div className="modal-footer">
                                <Button
                                  variant="outlined"
                                  className="action-button mr-4"
                                  onClick={clearFilterHandler}
                                >
                                  Clear
                                </Button>
                                <Button
                                  variant="contained"
                                  className="action-button"
                                  onClick={() => {
                                    applyFilterHandler();
                                    handleClose();
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </Popover>
                          <Tooltip placement="bottom" title="Filter">
                            <FilterAltOutlinedIcon
                              onClick={handleClick}
                              title="filter-icon"
                            />
                          </Tooltip>
                        </div>
                      </Grid>
                    )}
                </Grid>
              }

              {formik.values.distributorSubscriptionDomains?.map(
                (item, index) => renderDistSubscriptionItem(item, index)
              )}
              <FooterButtons
                isEditMode={isEditMode}
                permissions={permissions}
                permissionId={permissionId}
                editPermission={editPermissionSubscripiton}
                showUpdateNext={
                  formik.values.userId > 0 && props?.routeData?.userTypeId !== 7
                }
                showSaveNext={
                  !formik.values.userId && props?.routeData?.userTypeId !== 7
                }
                disableUpdateNext={
                  !isEditMode ||
                  !formik.isValid ||
                  getDateAlreadyExistsValidation()
                }
                disableSaveNext={
                  !isEditMode ||
                  !formik.isValid ||
                  getDateAlreadyExistsValidation()
                }
                showUpdateDetail={formik.values.userId > 0}
                disableUpdateDetail={
                  !isEditMode ||
                  Object.keys(formik.errors).length > 0 ||
                  getDateAlreadyExistsValidation()
                }
                disableSaveDetail={
                  !isEditMode ||
                  !formik.isValid ||
                  getDateAlreadyExistsValidation()
                }
                onCancel={onCancelHandler}
                onEdit={onEditHandler}
                onUpdateNext={() => updateDistributor(true)}
                onSaveNext={() => {
                  createDistributor(true);
                }}
                onUpdate={() => updateDistributor(false)}
                onSave={() => {
                  createDistributor(false);
                }}
              />
            </AccordionDetails>
          </Accordion>
        )}
      {/*  Subscription Details Screen ends */}

      {/* Enterprise Subscription Details Screen starts for subscribers */}
      {props.routeData.userTypeId === 7 && (
        <Accordion
          className="accordion-ent"
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography sx={{ fontWeight: "700" }}>
              Subscription Details
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {expanded === "panel4" &&
              formik.values?.egSubscriptions?.map((item, index) => {
                if (
                  auth.getRole() === SystemUsersEnum.SUPERADMIN ||
                  auth.getRole() === SystemUsersEnum.ADMIN
                ) {
                  return renderSubscriptionDetails(item, index);
                } else {
                  return item.distributorUserId ===
                    auth.getCurrentUser()?.userId ||
                    item.enterpriseUserId === auth.getCurrentUser()?.userId
                    ? renderSubscriptionDetails(item, index)
                    : null;
                }
              })}
            {associationPopupConfirmation && renderConfirmationPopup()}
          </AccordionDetails>
        </Accordion>
      )}
      {/* Enterprise Subscription Details Screen ends */}

    </>
  );

  function entBrandNameSection() {
    return (
      props?.routeData?.userTypeId === 7 &&
      (auth.getRole() === SystemUsersEnum.ADMIN ||
        auth.getRole() === SystemUsersEnum.SUPERADMIN ? (
        <Grid
          item
          sx={4}
          p={2}
          className="blue-field-section serachable-dropdown search-dropdown css-cus-css"
        >
          <label htmlFor="DistributorIDEnterpriseID">
            Enterprise Brand Name
          </label>
          <MultiSelectCheckboxSearchableDropdown
            from="subscriber"
            width="100%"
            multiple={true}
            setData={onChangeEnterpriseGroupId}
            name="searchSubscriber"
            value={getValueForField(formik.values.enterpriseIds, "ent")}
            id="searchSubscriber"
            className="multiple-associate-subscriber-dropdown"
            options={
              enterpriseTypes?.allEnterpriseUsers
                ? enterpriseTypes.allEnterpriseUsers
                : []
            }
            placeholder={
              !isEditMode ? "" : "Search and Select Enterprise Brand Name"
            }
            disabled={!isEditMode}
            noOptionsMessage="No new Enterprise to associate"
          />
        </Grid>
      ) : (
        <Grid item xs={4} p={2} className="blue-field-section">
          <label htmlFor="EnterpriseBrandName">Enterprise Brand Name</label>
          <MandatoryField />
          <input
            id="EnterpriseBrandName"
            name="EnterpriseBrandName"
            value={
              auth.getRole() === SystemUsersEnum.ENTERPRISE
                ? currentUserBrandName
                : ""
            }
            className="form-label form-control"
            type="text"
            placeholder="Enterprise Brand Name"
            disabled={true}
            maxLength={25}
          />
        </Grid>
      ))
    );
  }

  function distBrandNameSection() {
    const DistBrandNameWhenNotAdmin =
      auth.getRole() === SystemUsersEnum.ENTERPRISE ? (
        <Grid
          item
          sx={4}
          p={2}
          className="blue-field-section serachable-dropdown search-dropdown css-cus-css"
        >
          <label htmlFor="EnterpriseID">
            Associated Distributor Brand Names
          </label>
          <MultiSelectCheckboxSearchableDropdown
            from="subscriber"
            width="100%"
            multiple={true}
            name="searchSubscriber"
            value={entUserDists?.map((res) => {
              return {
                value: res.distributorUserId,
                label: res.brandName || "NA",
              };
            })}
            id="searchSubscriber"
            className="multiple-associate-subscriber-dropdown"
            options={entUserDists?.map((res) => {
              return {
                value: res.distributorUserId,
                label: res.brandName || "NA",
              };
            })}
            disabled={true}
            noOptionsMessage="No new Distributor to associate"
          />
        </Grid>
      ) : (
        <Grid item xs={4} p={2} className="blue-field-section">
          <label htmlFor="DistributorBrandName">Distributor Brand Name</label>
          <MandatoryField />
          <input
            id="DistributorBrandName"
            name="DistributorBrandName"
            value={currentUserBrandName}
            className="form-label form-control"
            type="text"
            placeholder="Distributor Brand Name"
            disabled={true}
            maxLength={25}
          />
        </Grid>
      );
    return (
      props?.routeData?.userTypeId === 7 &&
      (auth.getRole() === SystemUsersEnum.ADMIN ||
        auth.getRole() === SystemUsersEnum.SUPERADMIN ? (
        <Grid
          item
          sx={4}
          p={2}
          className="blue-field-section serachable-dropdown search-dropdown css-cus-css"
        >
          <label htmlFor="EnterpriseID">Distributor Brand Name</label>
          <MultiSelectCheckboxSearchableDropdown
            from="subscriber"
            width="100%"
            multiple={true}
            setData={onChangeDistributorUserId}
            name="searchSubscriber"
            value={getValueForField(formik.values.distributorIds, "dist")}
            id="searchSubscriber"
            className="multiple-associate-subscriber-dropdown"
            options={
              distributorTypes?.allDistributorUsers
                ? distributorTypes.allDistributorUsers
                : []
            }
            placeholder={
              !isEditMode ? "" : "Search and Select Distributor Brand Name"
            }
            disabled={!isEditMode}
            noOptionsMessage="No new Distributor to associate"
          />
        </Grid>
      ) : (
        DistBrandNameWhenNotAdmin
      ))
    );
  }

  function altFaxExistSection() {
    return showAnotherFax || props?.formData?.fax1 ? (
      <Grid item xs={4} p={2} className="blue-field-section">
        <label htmlFor="mobile1">Alternate Fax</label>
        <PhoneNumberTextbox
          id="fax1"
          className="form-label form-control"
          name="fax1"
          placeholder="Enter Alternate Fax"
          onChange={(e) => {
            formik.setFieldValue("dirty", true);
            formik.handleChange(e);
          }}
          value={formik.values.fax1}
          disabled={!isEditMode}
          phoneCode={getPhoneCode(countryOptions, formik.values.countryId)}
        />
        <InlineMessage error={formik.errors.fax1} />
      </Grid>
    ) : (
      <></>
    );
  }

  function altFaxMissingSection() {
    const shouldShowSection =
      (!props?.formData?.userId && !props?.formData?.fax1) ||
      (isEditMode && !props?.formData?.fax1);

    if (!shouldShowSection) return null;

    return (
      <Grid item xs={4} p={2} className="blue-field-section">
        <button
          type="button"
          name="AddAnotherFax"
          data-testid="AddAnotherFax"
          className="add-item"
          onClick={() => {
            if (showAnotherMobile) {
              formik.setValues({
                ...formik.values,
                fax1: "",
              });
            }
            setShowAnotherFax((prevValue) => !prevValue);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "block",
            width: "100%",
            padding: 0,
            textAlign: "left",
          }}
        >
          <h5 style={{ margin: 0 }}>
            <span>
              {showAnotherFax ? "- Remove Another Fax" : "+ Add Another Fax"}
            </span>
          </h5>
        </button>
      </Grid>
    );
  }

  function anotherMobileExistSection() {
    return showAnotherMobile || props?.formData?.mobile1 ? (
      <Grid item xs={4} p={2} className="blue-field-section">
        <label htmlFor="mobile1">Alternate Mobile</label>
        <PhoneNumberTextbox
          id="mobile1"
          className="form-label form-control"
          name="mobile1"
          placeholder="Enter Alternate Mobile Number"
          onChange={(e) => {
            formik.setFieldValue("dirty", true);
            formik.handleChange(e);
          }}
          value={formik.values.mobile1}
          disabled={!isEditMode}
          phoneCode={getPhoneCode(countryOptions, formik.values.countryId)}
        />
        <InlineMessage error={formik.errors.mobile1} />
      </Grid>
    ) : (
      <></>
    );
  }

  function anotherMobileMissingsection() {
    const shouldShowSection =
      (!props?.formData?.userId && !props?.formData?.mobile1) ||
      (isEditMode && !props?.formData?.mobile1);

    if (!shouldShowSection) return null;

    return (
      <Grid item xs={4} p={2} className="blue-field-section">
        <button
          type="button"
          name="AddAnotherMobile"
          data-testid="AddAnotherMobile"
          className="add-item"
          onClick={() => {
            if (showAnotherMobile) {
              formik.setValues({
                ...formik.values,
                mobile1: "",
              });
            }
            setShowAnotherMobile((prevValue) => !prevValue);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "block",
            width: "100%",
            padding: 0,
            textAlign: "left",
            color: "inherit",
          }}
          tabIndex={0} // ✅ ensures it's focusable by keyboard
          aria-pressed={showAnotherMobile} // ✅ conveys toggle state
        >
          <h5 style={{ margin: 0 }}>
            <span>
              {showAnotherMobile
                ? "- Remove Another Mobile"
                : "+ Add Another Mobile"}
            </span>
          </h5>
        </button>
      </Grid>
    );
  }

  function secNumberExistSection() {
    return showAnotherNumber || props?.formData?.secondaryPhoneNumber ? (
      <Grid item xs={4} p={2} className="blue-field-section">
        <label htmlFor="secondaryPhoneNumber">Secondary Phone Number</label>
        <BusinessPhoneNumberTextbox
          id="secondaryPhoneNumber"
          className="form-label form-control"
          name="secondaryPhoneNumber"
          placeholder="Enter Secondary Phone Number"
          onChange={(e) => {
            formik.setFieldValue("dirty", true);
            formik.setFieldValue("secondaryPhoneNumber", e);
          }}
          value={formik.values.secondaryPhoneNumber}
          disabled={!isEditMode}
          phoneCode={getPhoneCode(countryOptions, formik.values.countryId)}
        />
        <InlineMessage error={formik.errors.secondaryPhoneNumber} />
      </Grid>
    ) : (
      <></>
    );
  }

  function secNumberMissingSection() {
    const shouldShowSection =
      (!props?.formData?.userId && !props?.formData?.secondaryPhoneNumber) ||
      (isEditMode && !props?.formData?.secondaryPhoneNumber);

    if (!shouldShowSection) return null;

    return (
      <Grid item xs={4} p={2} className="blue-field-section">
        <button
          type="button"
          name="AddAnotherNumber"
          data-testid="AddAnotherNumber"
          className="add-item"
          onClick={() => {
            if (showAnotherNumber) {
              formik.setValues({
                ...formik.values,
                secondaryPhoneNumber: "",
              });
            }
            setShowAnotherNumber((prevValue) => !prevValue);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "block",
            width: "100%",
            padding: 0,
            textAlign: "left",
            color: "inherit",
          }}
          tabIndex={0} // ✅ ensures it's keyboard focusable
          aria-pressed={showAnotherNumber} // ✅ communicates toggle state
        >
          <h5 style={{ margin: 0 }}>
            <span>
              {showAnotherNumber
                ? "- Remove Another Number"
                : "+ Add Another Number"}
            </span>
          </h5>
        </button>
      </Grid>
    );
  }
};
CreateDistributorModal.propTypes = {
  basicDetailPermission: PropTypes.arrayOf(PropTypes.string).isRequired,
  associationDetailsPermission: PropTypes.arrayOf(PropTypes.string).isRequired,
  subscriptionDetailsPermission: PropTypes.arrayOf(PropTypes.string).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string),
  isEditMode: PropTypes.bool,
  onNext: PropTypes.func,
  getEditData: PropTypes.func,
  routeData: PropTypes.shape({
    userTypeId: PropTypes.number.isRequired,
    schema: PropTypes.shape({}),
    listRoute: PropTypes.string,
    userTypeLabel: PropTypes.string,
    distTypeError: PropTypes.string,
    addRoute: PropTypes.string,
    editRoute: PropTypes.string,
  }).isRequired,
  formData: PropTypes.shape({
    userId: PropTypes.number,
    parentUser: PropTypes.shape({
      parentUserId: PropTypes.number,
      permissions: PropTypes.arrayOf(
        PropTypes.shape({
          parentUserPermissionId: PropTypes.number,
          userId: PropTypes.number,
          parentUserId: PropTypes.number,
          parentPermissionMasterId: PropTypes.number,
          isRead: PropTypes.bool,
          isWrite: PropTypes.bool,
          isNoAccess: PropTypes.bool,
        })
      ),
    }),
    roles: PropTypes.array, // array of role objects (name, id, etc.)
    status: PropTypes.number,
    enterpriseIds: PropTypes.array, // can be array of ids or option objects (normalized later)
    distributorIds: PropTypes.array, // same as above
    parentUserId: PropTypes.number,
    businessName: PropTypes.string,
    brandName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    distributorType: PropTypes.array, // react-select option objects
    primaryEmail: PropTypes.string,
    secondaryEmail: PropTypes.string,
    carriers: PropTypes.array,
    carrierRepresents: PropTypes.array,
    areas: PropTypes.array,
    producers: PropTypes.string,
    industryGroups: PropTypes.array,
    technologies: PropTypes.array,
    businessYear: PropTypes.string,
    websiteUrl: PropTypes.string,
    annualRevenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    numberOfEmployees: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    numberOfOwners: PropTypes.string,
    phoneNumber: PropTypes.string,
    secondaryPhoneNumber: PropTypes.string,
    mobile: PropTypes.string,
    mobile1: PropTypes.string,
    fax: PropTypes.string,
    fax1: PropTypes.string,
    billingContact: PropTypes.string,
    billingContactLastName: PropTypes.string,
    billingPhoneNumber: PropTypes.string,
    billingAddressLine1: PropTypes.string,
    billingAddressLine2: PropTypes.string,
    isSmsConsentGiven: PropTypes.bool,
    isShippingAddressSameAsBilling: PropTypes.bool,
    shippingContactName: PropTypes.string,
    shippingContactLastName: PropTypes.string,
    shippingPhoneNumber: PropTypes.string,
    shippingAddressLine1: PropTypes.string,
    shippingAddressLine2: PropTypes.string,
    shippingCountryId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    shippingStateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    shippingCity: PropTypes.string,
    shippingZipCode: PropTypes.string,
    countryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    city: PropTypes.string,
    zip: PropTypes.string,
    logoGcpPath: PropTypes.string,
    logoGcpFileUrl: PropTypes.string,
    distributorSubscriptionDomains: PropTypes.arrayOf(
      PropTypes.shape({
        distributorSubscriptionId: PropTypes.number,
        uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        status: PropTypes.number,
        subscriptionPlan: PropTypes.arrayOf(
          PropTypes.shape({
            baseValue: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number,
            ]),
            distributorSubscriptionPlanId: PropTypes.number,
            distributorSubscriptionId: PropTypes.number,
            uniqueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            frequency: PropTypes.number,
            effectiveFromDate: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.instanceOf(Date),
              PropTypes.oneOf([null]),
            ]),
            effectiveToDate: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.instanceOf(Date),
              PropTypes.oneOf([null]),
            ]),
            savedEffectiveToDate: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.instanceOf(Date),
              PropTypes.oneOf([null]),
            ]),
            isAssociated: PropTypes.bool,
            status: PropTypes.number,
          })
        ),
      })
    ),
    egSubscriptions: PropTypes.arrayOf(
      PropTypes.shape({
        brandName: PropTypes.string,
        distBrandName: PropTypes.string,
        subscriptionName: PropTypes.string,
        subscriptionFees: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
        frequencyType: PropTypes.number,
        isRecurring: PropTypes.bool,
        startDate: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.instanceOf(Date),
          PropTypes.oneOf([null]),
        ]),
        endDate: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.instanceOf(Date),
          PropTypes.oneOf([null]),
        ]),
        documentType: PropTypes.number,
        distributorUserId: PropTypes.number,
        enterpriseUserId: PropTypes.number,
        isEgSubscription: PropTypes.bool,
      })
    ),
    userAddOns: PropTypes.arrayOf(
      PropTypes.shape({
        userId: PropTypes.number,
        addOnType: PropTypes.number,
        isActive: PropTypes.bool,
      })
    ),
    systemGeneratedId: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

CreateDistributorModal.defaultProps = {
  permissions: [],
  isEditMode: false,
  onNext: () => { },
  getEditData: () => { },
  formData: {
    parentUser: { parentUserId: 0, permissions: [] },
    distributorSubscriptionDomains: [],
    egSubscriptions: [],
    userAddOns: [],
    isSmsConsentGiven: false,
    isShippingAddressSameAsBilling: true,
    shippingContactName: "",
    shippingContactLastName: "",
    shippingPhoneNumber: "",
    shippingAddressLine1: "",
    shippingAddressLine2: "",
    shippingCountryId: null,
    shippingStateId: null,
    shippingCity: "",
    shippingZipCode: "",
  },
};

export default CreateDistributorModal;

function isAllSelectedFunction(options, selected) {
  return options && options.length > 0 && selected.length === options.length;
}

function formatUSZipCode(value) {
  value = value.replaceAll(/\D/g, "");
  if (value.length > 5) {
    value = value.slice(0, 5) + "-" + value.slice(5, 9);
  }
  return value.slice(0, 10);
}
/*istanbul ignore next */
function formatCanadianPostalCode(value) {
  value = value.replaceAll(/\s/g, "").toUpperCase();
  const validFirstLetter = /^[ABCEGHJKLMNPRSTVXY]/;
  if (!validFirstLetter.test(value.charAt(0))) {
    return "";
  }
  value = value.replaceAll(/[^A-Z0-9]/g, "").slice(0, 6);
  if (value.length > 3) {
    value = value.slice(0, 3) + " " + value.slice(3);
  }
  return value;
}

/*istanbul ignore next */
function renderAddButton(
  isEditMode,
  subIndex,
  topIndex,
  addNewSubscriptionFrequency,
  index
) {
  return showAddButton(isEditMode, subIndex, topIndex) ? (
    <Grid
      style={{
        paddingRight: "5px",
      }}
    >
      <Tooltip placement="bottom" title="Add">
        <AddOutlinedIcon
          name="add-icon"
          title="add-icon"
          style={{ marginLeft: "40px" }}
          onClick={() => {
            addNewSubscriptionFrequency(index);
          }}
        />
      </Tooltip>
    </Grid>
  ) : (
    <Grid
      style={{
        paddingRight: "82px",
      }}
    ></Grid>
  );
}

/*istanbul ignore next */
function renderActiveInactiveDeleteButton(subItem) {
  return subItem.isAssociated ? (
    <img src={Group2252519} alt="Disabled Delete" height={35} />
  ) : (
    <img src={Group2252459} alt="Delete" height={35} />
  );
}

/*istanbul ignore next */
function activeInactiveGridClass(formik, index, subIndex) {
  return `blue-field-section${formik.values.distributorSubscriptionDomains[index]?.subscriptionPlan[
      subIndex
    ]?.status === 1
      ? "active-record"
      : ""
    }`;
}

/*istanbul ignore next */
function activeInactiveGlobalClass(index, formik, subIndex) {
  return `subscription${index} ${formik.values.distributorSubscriptionDomains[index]?.subscriptionPlan[
      subIndex
    ]?.status === 1
      ? "active-record"
      : ""
    }`;
}

/*istanbul ignore next */
function hasSubPlans(subPlans) {
  return subPlans && subPlans.length > 0;
}

/*istanbul ignore next */
function createUserSuccess(
  page,
  response,
  setIsEditMode,
  props,
  executeScroll,
  isNext,
  history
) {
  page.setDirty(false);
  toast.success(response.responseStatus.description);
  page.setEditMode(false);

  setIsEditMode(
    (props.formData.status > 0 ||
      props.routeData?.userTypeId !== SystemUsersEnum.DISTRIBUTOR) &&
    page.isEditMode
  );

  setTimeout(() => {
    executeScroll();
  });

  setTimeout(() => {
    if (isNext) {
      props.onNext(isNext, response.result);
      return; // ✅ early return avoids nested else-only block
    }

    const { userTypeId, editRoute } = props.routeData || {};
    const userId = response.result.userId;

    if (userTypeId === 7) {
      history.push(`${editRoute.replace(":id", userId)}`);
    } else {
      history.push(
        `${editRoute.replace(":id", userId)}/${TABS.INTERNAL_USERS}`
      );
    }
  }, 3000);
}

/*istanbul ignore next */
function setRolesMethod(allRoles, selected, payload) {
  let roles =
    allRoles?.filter((element) => selected.includes(element.name)) || [];
  payload.roles = roles;
}
/*istanbul ignore next */
function showAddButton(isEditMode, subIndex, topIndex) {
  return isEditMode && subIndex === topIndex;
}
/*istanbul ignore next */
function getEToDateValidationMessage(
  formik,
  index,
  subIndex,
  effToDateRangeExists
) {
  return (
    (formik.errors?.distributorSubscriptionDomains?.length > 0 &&
      index < formik.errors.distributorSubscriptionDomains?.length &&
      formik.errors.distributorSubscriptionDomains[index]?.subscriptionPlan
        ?.length > 0 &&
      subIndex <
      formik.errors.distributorSubscriptionDomains[index].subscriptionPlan
        .length &&
      formik.errors.distributorSubscriptionDomains[index]?.subscriptionPlan[
        subIndex
      ]?.effectiveToDate) ||
    (effToDateRangeExists &&
      "Date already exists for this frequency. Please enter valid date")
  );
}
/*istanbul ignore next */
function disableEToDate(isEditMode, subItem, item) {
  return (
    !isEditMode ||
    (subItem.distributorSubscriptionPlanId > 0 &&
      subItem.savedEffectiveToDate) ||
    item.subscriptionPlan.find(
      (x) =>
        !x.distributorSubscriptionPlanId > 0 &&
        subItem.distributorSubscriptionPlanId > 0 &&
        x.frequency === subItem.frequency
    ) ||
    !subItem.effectiveFromDate
  );
}
/*istanbul ignore next */
function getEFromDateValidationMessage(
  formik,
  index,
  subIndex,
  effFromDateRangeExists
) {
  return (
    (formik.errors?.distributorSubscriptionDomains?.length > 0 &&
      index < formik.errors.distributorSubscriptionDomains?.length &&
      formik.errors.distributorSubscriptionDomains[index]?.subscriptionPlan
        ?.length > 0 &&
      subIndex <
      formik.errors.distributorSubscriptionDomains[index].subscriptionPlan
        .length &&
      formik.errors.distributorSubscriptionDomains[index]?.subscriptionPlan[
        subIndex
      ]?.effectiveFromDate) ||
    (effFromDateRangeExists &&
      "Date already exists for this frequency. Please enter valid date")
  );
}
/*istanbul ignore next */
function getFrequencyOptions(frequencyOptions, item, subItem) {
  return frequencyOptions
    ?.filter((x) => {
      let filteredValues =
        item?.subscriptionPlan?.filter(
          (y) =>
            y?.frequency === x?.value &&
            y?.uniqueId !== subItem?.uniqueId &&
            (!y?.effectiveToDate ||
              moment(y?.effectiveToDate).isAfter(
                moment(new Date().setHours(0, 0, 0, 0))
              ))
        ) || [];
      return (
        subItem?.distributorSubscriptionPlanId > 0 ||
        (filteredValues.length < 2 &&
          filteredValues?.filter(
            (val) => !val?.distributorSubscriptionPlanId > 0
          )?.length < 1)
      );
    })
    ?.map((res) => (
      <option key={res?.value} value={res?.value}>
        {res?.label}
      </option>
    ));
}
/*istanbul ignore next */
function baseValueValidation(formik, index, subIndex) {
  return (
    formik.errors?.distributorSubscriptionDomains?.[index]?.subscriptionPlan?.[
      subIndex
    ]?.baseValue || ""
  );
}

/*istanbul ignore next */
function setBaseValue(formik, index, subIndex, e, page) {
  if (e === "" || e === null) {
    formik.setFieldValue(
      `distributorSubscriptionDomains[${index}].subscriptionPlan[${subIndex}].baseValue`,
      null
    );
    page.setDirty(true);
    return;
  }
  let strVal = e.toString();
  let [whole, decimal] = strVal.split(".");
  if (!decimal) {
    if (whole.length > 6) return;
  } else {
    if (decimal.length > 2) {
      decimal = decimal.slice(0, 2);
    }
    if (whole.length + decimal.length > 8) return;
    strVal = `${whole}.${decimal}`;
  }
  formik.setFieldValue(
    `distributorSubscriptionDomains[${index}].subscriptionPlan[${subIndex}].baseValue`,
    strVal
  );
  page.setDirty(true);
}

/*istanbul ignore next */
function subPlanValidation(filterQuery, subItem) {
  return (
    (filterQuery.frequency.includes(subItem.frequency) &&
      filterQuery.status.includes(subItem.status)) ||
    !subItem.distributorSubscriptionPlanId > 0
  );
}
/*istanbul ignore next */
function effectiveDateRange(subItem, minFromDate) {
  const safeMinDate = new Date(Math.max(minFromDate, new Date()));
  const compareDate = new Date(safeMinDate.setHours(0, 0, 0, 0));
  const effFromDateRangeExists =
    !subItem?.distributorSubscriptionPlanId > 0 &&
    subItem?.effectiveFromDate &&
    new Date(
      subItem.effectiveFromDate.replaceAll("-", "/").replaceAll(/T.+/g, "")
    ) < compareDate;
  const effToDateRangeExists =
    !subItem?.distributorSubscriptionPlanId > 0 &&
    subItem?.effectiveToDate &&
    new Date(
      subItem.effectiveToDate.replaceAll("-", "/").replaceAll(/T.+/g, "")
    ) < compareDate;
  return { effFromDateRangeExists, effToDateRangeExists };
}

/*istanbul ignore next */
function addButtonIndex(filterQuery, x) {
  return (
    (filterQuery.frequency.includes(x.frequency) &&
      filterQuery.status.includes(x.status)) ||
    !x.distributorSubscriptionPlanId > 0
  );
}
/*istanbul ignore next */
function NameValidationMessage(formik, index) {
  return formik.errors?.distributorSubscriptionDomains?.[index]?.name || "";
}
/*istanbul ignore next */
function applyFilterOnPlan(item, filterQuery) {
  if (!Array.isArray(item?.subscriptionPlan)) return [];
  return item.subscriptionPlan.filter((x) => addButtonIndex(filterQuery, x));
}
/* istanbul ignore next */
function reversePayloadSubs(payload) {
  if (!Array.isArray(payload?.distributorSubscriptionDomains)) return;

  payload.distributorSubscriptionDomains.forEach((element) => {
    if (Array.isArray(element?.subscriptionPlan)) {
      element.subscriptionPlan = [...element.subscriptionPlan].reverse();
    }
  });
  payload.distributorSubscriptionDomains = [
    ...payload.distributorSubscriptionDomains,
  ].reverse();
}
/*istanbul ignore next */
function getMinFromAndToDate(item, subItem) {
  const plans =
    item && Array.isArray(item.subscriptionPlan) ? item.subscriptionPlan : [];

  let minFromDate = new Date(
    Math.max(
      null,
      ...plans
        .filter(
          (x) =>
            x.frequency === subItem.frequency && x.uniqueId !== subItem.uniqueId
        )
        .map((e) => new Date(e.effectiveFromDate)),
      ...plans
        .filter(
          (x) =>
            x.frequency === subItem.frequency && x.uniqueId !== subItem.uniqueId
        )
        .map((e) => new Date(e.effectiveToDate))
    )
  );
  let minToDate = new Date(subItem.effectiveFromDate);
  minFromDate.setDate(minFromDate.getDate() + 1);
  minToDate.setDate(minToDate.getDate());
  return { minFromDate, minToDate };
}
/*istanbul ignore next */
function validateSubscriptions(distributorSubscriptionDomains) {
  let isDuplicate = false;
  if (
    distributorSubscriptionDomains &&
    distributorSubscriptionDomains.length > 0
  ) {
    let valueArr = distributorSubscriptionDomains.map(function (item) {
      return item.name?.trim()?.toLowerCase();
    });
    isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) != idx;
    });
  }
  return isDuplicate;
}
/*istanbul ignore next */
function forNormalSubPlanFields(field, formik, index, subIndex, e) {
  if (field === "frequency") {
    formik.setFieldValue(
      `distributorSubscriptionDomains[${index}].subscriptionPlan[${subIndex}].${field}`,
      Number(e.target.value)
    );
  } else {
    formik.setFieldValue(
      `distributorSubscriptionDomains[${index}].subscriptionPlan[${subIndex}].${field}`,
      e.target.value
    );
  }
}
/*istanbul ignore next */
function loadBasidDetails(basicDetailPermission, props) {
  return (
    basicDetailPermission.includes(PermissionEnum.LIST) ||
    props?.routeData?.userTypeId === 7
  );
}
/*istanbul ignore next */
function primaryEmailAdmin(
  auth,
  isEditMode,
  editMode,
  formik,
  handleEditClick
) {
  const isAdmin =
    auth.getRole() === SystemUsersEnum.ADMIN ||
    auth.getRole() === SystemUsersEnum.SUPERADMIN;

  return isAdmin ? (
    <Grid item xs={4} p={2} className="blue-field-section">
      <label htmlFor="primaryEmail">Primary Email Address</label>
      <MandatoryField />
      {isEditMode && !editMode && formik.values.primaryEmail !== "" && (
        <button
          type="button"
          onClick={handleEditClick}
          className="cus-height-createOutlinedIcon"
          aria-label="Edit Primary Email"
          style={{
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            cursor: "pointer",
          }}
          data-testid="EditPrimaryEmailButton"
        >
          <CreateOutlinedIcon />
        </button>
      )}

      {editModePrimaryEmail(formik, editMode, isEditMode)}
    </Grid>
  ) : (
    <Grid item xs={4} p={2} className="blue-field-section">
      <label htmlFor="primaryEmail">Primary Email Address</label>
      <MandatoryField />
      {formik.values.id ? (
        <a
          className="primary-email-url"
          href={`mailto:${formik.values.primaryEmail}`}
        >
          {formik.values.primaryEmail}
        </a>
      ) : (
        <>
          <input
            id="primaryEmail"
            name="primaryEmail"
            value={formik.values.primaryEmail}
            onChange={formik.handleChange}
            className="form-label form-control"
            type="text"
            placeholder="Enter Primary Email Address"
          />
          <InlineMessage error={formik.errors.primaryEmail} />
        </>
      )}
    </Grid>
  );
}

/*istanbul ignore next */
function editModePrimaryEmail(formik, editMode, isEditMode) {
  return formik.values.id ? (
    <>
      {editMode ? (
        <div>
          <input
            id="primaryEmail"
            name="primaryEmail"
            value={formik.values.primaryEmail}
            onChange={formik.handleChange}
            className="form-label form-control"
            type="text"
            placeholder="Enter Primary Email Address"
            disabled={!isEditMode}
          />
          <InlineMessage error={formik.errors.primaryEmail} />
        </div>
      ) : (
        <a
          className="primary-email-url"
          href={`mailto:${formik.values.primaryEmail}`}
        >
          {formik.values.primaryEmail}
        </a>
      )}
    </>
  ) : (
    <>
      <input
        id="primaryEmail"
        name="primaryEmail"
        value={formik.values.primaryEmail}
        onChange={formik.handleChange}
        className="form-label form-control"
        type="text"
        placeholder="Enter Primary Email Address"
        disabled={!isEditMode}
      />
      <InlineMessage error={formik.errors.primaryEmail} />
    </>
  );
}

/*istanbul ignore next */
function getLogoText(logo, formik) {
  return logo || formik.values.logoGcpPath ? (
    <span className="filename">Replace File</span>
  ) : (
    <span className="filename">Choose File</span>
  );
}

/*istanbul ignore next */
function formattingPayload(payload, props, auth, currentUserId) {
  if (
    props?.routeData?.userTypeId === 7 &&
    auth.getRole() === SystemUsersEnum.ENTERPRISE
  ) {
    if (!payload.enterpriseIds?.find((x) => x === currentUserId)) {
      payload.enterpriseIds = [...payload.enterpriseIds, currentUserId];
    }
  } else if (
    props?.routeData?.userTypeId === 7 &&
    auth.getRole() === SystemUsersEnum.DISTRIBUTOR
  ) {
    if (!payload.distributorIds?.find((x) => x === currentUserId)) {
      payload.distributorIds = [...payload.distributorIds, currentUserId];
    }
  }
}
